<template>
  <div class="page checkout">

    <!--<div class="absBack"> -->
    <!--           <div onclick="window.history.back()"> -->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon> -->
    <!--            </div> -->

    <!--        </div> -->


    <h2 class="text-center mt-7" style="margin-bottom: 2px;">Bestellung zur Lieferung</h2>
    <div class="text-center">
      <!--            <h2 style="margin-bottom: 20px" v-if="usecase === 'takeAway'">Gesamtsumme: {{total | priceTotal}}</h2>-->
      <!--            <h2 style="margin-bottom: 20px" v-else>Gesamtsumme: {{total | priceTotal}}</h2>-->
      <h4 class="">Gesamtsumme: <span class="textFont">{{ total | priceTotal }}</span></h4>
      <h4><span v-if="deliveryFee">inkl. </span>Liefergebühr: <span
          class="textFont">{{ deliveryFee | priceTotal }}</span></h4>
      <h4 class="mt-2">Zahlung bei Lieferung</h4>
      <!--            <div>Bestellen zum Abholen</div>-->
    </div>

    <v-container class="ccontainer" grid-list-md>
      <!--        <v-container class="bigger-input" grid-list-md>-->

      <div class="kioskCheckoutContainer">
        <v-stepper v-model="currentStep" vertical class="vvd orderform" id="stepper">

          <v-stepper-step :complete="currentStep > 1" step="1" @click.native.passive="currentStep = 1">
            <div class="nice-title small">Deine Bestelldaten</div>
            <!--                    <div class="nice-title small">Bitte überprüfe deine Daten</div>-->
          </v-stepper-step>
          <v-stepper-content step="1">
            <!--                    <div v-if="!hasFd" class="hinweis">-->
            <!--                        &lt;!&ndash;                        <v-icon>mdi-information-variant</v-icon>&ndash;&gt;-->
            <!--                        <div>Deine Eingabe wird lokal gespeichert, um zukünftige Bestellungen zu erleichtern 👍</div>-->
            <!--                    </div>-->
            <!--                    <h4 class="mb-1" v-if="asGuest">Bestellung als Gast</h4>-->
            <div v-if="usecase.length > 0" id="checkData">
              <!--                        <h4>Überprüfe deine Daten&nbsp;&nbsp;<v-icon @click.passive.native="gotoAccount">mdi-pencil-->
              <!--                        </v-icon>-->
              <!--                        </h4>-->
              <div class="bestelldaten pt-1">
                <v-form v-show="showForm" @submit.prevent="" ref="deliveryMpDataForm" v-model="valid" lazy-validation>
                  <v-text-field
                    outlined
                    v-model="name"
                    label="Vor- und Nachname*"
                    placeholder="Vorname Nachname"
                    illed hide-details
                    required
                    @focus="hideToolbar"
                    @blur="unhideToolbar"
                  ></v-text-field>
                  <!--                                <v-text-field-->
                  <!--                                        v-model="kundennummer"-->
                  <!--                                        label="Kundennummer (optional)"-->
                  <!--                                        placeholder="Deine Kundennummer"-->
                  <!--                                        illed hide-details-->
                  <!--                                        @focus="hideToolbar"-->
                  <!--                                        @blur="unhideToolbar"-->
                  <!--                                ></v-text-field>-->
                  <v-text-field
                    outlined
                    v-model="email"
                    label="E-Mail* (Bestelleingangsbestätigung)"
                    placeholder="E-Mail Adresse"
                    illed hide-details
                    required
                    @focus="hideToolbar"
                    @blur="unhideToolbar"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    ref="phone"
                    @keydown="phoneKeydown($event)"
                    v-model="phone"
                    :rules="phoneRules"
                    label="Mobilnummer*"
                    placeholder="Für evtl. Rückfragen"
                    illed
                    required
                  ></v-text-field>
                  <!--                                label="Mobilnummer* (ohne Ländervorwahl)"-->
                  <!--                            <pre v-if="$refs.phone">-->
                  <!--      hasError: {{$refs.phone.hasError}}-->
                  <!--      valid: {{$refs.phone.valid}}-->
                  <!--    </pre>-->
                  <!--                <p class="hinweis">Hinweis: Deine Daten werden nur zum Zweck dieser Bestellung-->
                  <!--                  verwendet und nicht-->
                  <!--                  &lt;!&ndash;                                zu keinem Zeitpunkt &ndash;&gt;-->
                  <!--                  an Dritte weitergegeben. Deine Mobilnummer benötigen wir für evtl.-->
                  <!--                  Rückfragen.</p>-->

                  <h4 class="mt-7 mb-4">Lieferadresse</h4>
                  <!--                            <form>-->
                  <!--                <v-text-field-->
                  <!--                  outlined-->
                  <!--                  clearable-->
                  <!--                  v-model="deliveryAddress.company"-->
                  <!--                  label="Firma (optional)"-->
                  <!--                  illed hide-details-->
                  <!--                  required-->
                  <!--                  @focus="hideToolbar"-->
                  <!--                  @blur="unhideToolbar"-->
                  <!--                ></v-text-field>-->
                  <v-text-field
                    outlined
                    clearable
                    v-model="deliveryAddress.street"
                    :rules="streetRules"
                    label="Straße und Hausnummer*"
                    illed hide-details
                    required
                    @focus="hideToolbar"
                    @blur="unhideToolbar"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    clearable
                    v-model="deliveryAddress.plz"
                    label="Postleitzahl*"
                    :rules="plzRules"
                    illed hide-details
                    required
                    @focus="hideToolbar"
                    @blur="unhideToolbar"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    clearable
                    v-model="deliveryAddress.city"
                    label="Stadt*"
                    :rules="cityRules"
                    illed hide-details
                    required
                    @focus="hideToolbar"
                    @blur="unhideToolbar"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    clearable
                    v-model="deliveryAddress.etage"
                    label="Etage"
                    illed hide-details
                    @focus="hideToolbar"
                    @blur="unhideToolbar"
                  ></v-text-field>
                  <div>
                    <img alt="powered by Google Maps" src="../assets/s-powered-by-Google-Maps.png" class="poweredByGoogleMaps">
                  </div>

                  <!--                                <table class="maxw myTable">-->
                  <!--                                    <tr>-->
                  <!--                                        <td>-->
                  <!--                                            <v-text-field-->
                  <!--                                                    v-model="invoiceAddress.plz"-->
                  <!--                                                    label="PLZ*"-->
                  <!--                                                    illed hide-details-->
                  <!--                                                    required-->
                  <!--                                                    @focus="hideToolbar"-->
                  <!--                                                    @blur="unhideToolbar"-->
                  <!--                                            ></v-text-field>-->
                  <!--                                        </td>-->
                  <!--                                        <td>-->
                  <!--                                            <v-text-field-->
                  <!--                                                    v-model="invoiceAddress.city"-->
                  <!--                                                    label="Stadt*"-->
                  <!--                                                    illed hide-details-->
                  <!--                                                    required-->
                  <!--                                                    @focus="hideToolbar"-->
                  <!--                                                    @blur="unhideToolbar"-->
                  <!--                                            ></v-text-field>-->
                  <!--                                        </td>-->
                  <!--                                    </tr>-->
                  <!--                                </table>-->


                  <v-checkbox
                    class="d-inline-block vvd-dynlight vvd-force"
                    v-model="sameAsDeliveryAddress"
                    label="Rechnungsadresse gleich Lieferadresse"
                  ></v-checkbox>

                  <div v-if="!sameAsDeliveryAddress">
                    <h4 class="mt-7 mb-4">Rechnungsadresse</h4>
                    <v-text-field
                      outlined
                      clearable
                      v-model="invoiceAddress.company"
                      label="Firma (optional)"
                      illed hide-details
                      required
                      @focus="hideToolbar"
                      @blur="unhideToolbar"
                    ></v-text-field>
                    <v-text-field
                      outlined
                      clearable
                      v-model="invoiceAddress.street"
                      label="Straße und Hausnummer*"
                      illed hide-details
                      required
                      @focus="hideToolbar"
                      @blur="unhideToolbar"
                    ></v-text-field>
                    <v-text-field
                      outlined
                      clearable
                      v-model="invoiceAddress.plz"
                      label="Postleitzahl*"
                      illed hide-details
                      required
                      @focus="hideToolbar"
                      @blur="unhideToolbar"
                    ></v-text-field>
                    <v-text-field
                      outlined
                      clearable
                      v-model="invoiceAddress.city"
                      label="Stadt*"
                      illed hide-details
                      required
                      @focus="hideToolbar"
                      @blur="unhideToolbar"
                    ></v-text-field>
                  </div>

                </v-form>
              </div>


              <!--                        <div class="bestelldaten pointer" v-else @click.passive="gotoAccount">-->
              <!--                                                        <table>-->
              <!--                                                            <tr>-->
              <!--                                                                <td>Firma (optional):</td>-->
              <!--                                                                <td>{{company}}-->
              <!--                                                                    <v-icon @click.passive.native="gotoAccount">mdi-pencil-->
              <!--                                                                    </v-icon>-->
              <!--                                                                </td>-->
              <!--                                                            </tr>-->
              <!--                                                            <tr>-->
              <!--                                                                <td>Name:</td>-->
              <!--                                                                <td>{{$store.state.user.name}}-->
              <!--                                                                    <v-icon @click.passive.native="gotoAccount">mdi-pencil-->
              <!--                                                                    </v-icon>-->
              <!--                                                                </td>-->
              <!--                                                            </tr>-->
              <!--                                                            <tr>-->
              <!--                                                                <td>Mobilnummer:</td>-->
              <!--                                                                <td>{{$store.state.user.phone}}-->
              <!--                                                                    <v-icon @click.passive.native="gotoAccount">mdi-pencil-->
              <!--                                                                    </v-icon>-->
              <!--                                                                </td>-->
              <!--                                                            </tr>-->
              <!--                                                        </table>-->
              <!--                        </div>-->

              <!--                        <div class="spacer-15"></div>-->
              <!--                        <div class="pointer" @click.passive="changeFiliale"><h4 class="d-inline-block">Abholort</h4>-->
              <!--                            <v-icon>mdi-pencil</v-icon>-->
              <!--                        </div>-->
              <!--                        <div>{{$store.getters.selectedStore.strasse}}</div>-->
              <!--                        <div>{{$store.getters.selectedStore.plz}} {{$store.getters.selectedStore.ort}}-->
              <!--                        </div>-->


              <!--                        <table>-->
              <!--                            <tr>-->
              <!--                                <td class="vtop"><h4>Abholort</h4>-->
              <!--                                    <div>{{$store.getters.selectedStore.strasse}}</div>-->
              <!--                                    <div>{{$store.getters.selectedStore.plz}} {{$store.getters.selectedStore.ort}}-->
              <!--                                    </div>-->
              <!--                                </td>-->
              <!--                                <td style="width: 2vw"></td>-->
              <!--                                <td class="vtop"><h4>Öffungszeit Morgen</h4>-->
              <!--                                    <div>{{$store.getters.selectedStore.openingHours | tomorrow}}</div>-->
              <!--                                </td>-->
              <!--                                <td style="width: 1vw"></td>-->
              <!--                                <td class="vtop"><h4>Mindestbestellwert</h4>-->
              <!--                                    <div> {{$store.getters.selectedStore.minOrderAmount | price}}</div>-->
              <!--                                </td>-->
              <!--                            </tr>-->
              <!--                        </table>-->
              <!--                        <h4>Abholdatum</h4>-->
              <!--                        Morgen, {{displayTomorrow}}-->
              <!--                        <v-text-field-->
              <!--                                hide-details-->
              <!--                                illed-->
              <!--                                disabled-->
              <!--                                class="d-inline-block"-->
              <!--                                :value="displayTomorrow"-->
              <!--                        ></v-text-field>-->

              <!--                        <div class="spacer-15"></div>-->
              <!--                        <h4 class="d-inline-block">Abholzeit:</h4><span class="ml-2">Morgen, {{displayTomorrow}}</span>-->
              <!--                        <p>Je genauer Sie die Uhrzeit angeben, desto frischer erhalten Sie Ihre Backwaren!</p>-->

              <!--                        <h5 class="d-inline-block mr-3 text-none"-->
              <!--                            :class="{pulsing: !(time && time.value)}"-->
              <!--                        >Frühstens ab</h5>-->

              <!--                        <v-select-->
              <!--                                hide-details-->
              <!--                                :items="times"-->
              <!--                                item-text="display"-->
              <!--                                v-model="time"-->
              <!--                                class="d-inline-block abholzeit"-->
              <!--                                :class="{selectBlinker: !(time && time.value)}"-->
              <!--                                return-object-->
              <!--                                illed-->
              <!--                                placeholder="Wählen Sie eine Abholzeit aus"-->
              <!--                        ></v-select>-->
              <!--                        <div class="spacer-15"></div>-->


              <!--                            <h4>Bemerkung zu deiner Bestellung</h4>-->
              <template v-if="$store.state.enableOrderNote">
                <h4 class="mt-4">Hinweise zur Bestellung</h4>
                <v-text-field
                  hide-details
                  v-model="note"
                  class="nolabel"
                  clearable
                  illed
                ></v-text-field>
              </template>

              <div class="mt-2">
                <div class="error--text mt-2 mb-4" v-if="step1Error && initialTry">{{ step1Error }}</div>
                <v-btn class="primepulsing btn-df weiter" @click.native.passive="finishStep1">
                  Weiter
                </v-btn>
              </div>
              <!--                    <v-btn class="mt-3"-->
              <!--                           @click.native.passive="currentStep = 1">-->
              <!--                        Zurück-->
              <!--                    </v-btn>-->
            </div>


            <!--                <v-btn color="primary" @click="currentStep = 2">Continue</v-btn>-->
          </v-stepper-content>


          <v-stepper-step :complete="currentStep > 2" step="2">
            <div class="nice-title small">Lieferzeit: {{ selectedAbholDatum.value }}
              <span v-if="userSelectedHeute && timesToday.length > 0 && time">, {{ time.value }} Uhr</span><span
                v-if="!userSelectedHeute && timesTomorrow.length > 0 && time">, {{ time.value }} Uhr</span>
            </div>
          </v-stepper-step>
          <v-stepper-content id="lieferung" step="2">
            <v-layout row wrap>
              <v-flex xs12 md3>
                <div class="d-flex flex-nowrap flex-md-wrap">
                  <h4 class="flex-shrink-0 flex-grow-0 flex-md-grow-1 mr-2 breakTitle text-no-wrap"
                  >Datum:</h4>
                  <v-select
                    hide-details
                    :items="abholDatumArray"
                    item-text="value"
                    v-model="selectedAbholDatum"
                    return-object
                    illed
                  ></v-select>
                </div>
              </v-flex>
              <v-flex xs12 md1 class="hidden-sm-and-down">
              </v-flex>
              <v-flex xs12 md4>

                <div class="d-flex flex-nowrap flex-md-wrap">
                  <h4 class="flex-shrink-0 flex-grow-0 flex-md-grow-1 mr-2 breakTitle text-no-wrap"
                  >Lieferzeit:</h4>
                  <v-select
                    v-if="selectedAbholDatum.value === 'Heute'"
                    hide-details
                    :items="timesToday"
                    item-text="display"
                    v-model="time"
                    :class="{selectBlinker: !(time && time.value)}"
                    return-object
                    illed
                    placeholder="Uhrzeit auswählen"
                  ></v-select>
                  <v-select
                    v-if="selectedAbholDatum.value === 'Morgen'"
                    hide-details
                    :items="timesTomorrow"
                    item-text="display"
                    v-model="time"
                    :class="{selectBlinker: !(time && time.value)}"
                    return-object
                    illed
                    placeholder="Uhrzeit auswählen"
                  ></v-select>
                </div>
              </v-flex>
            </v-layout>


            <!--                    <h4 class="mt-7 mb-1">Abholadresse:</h4>-->
            <!--                    <div>-->
            <!--                        &lt;!&ndash;                                            <h4 class="d-inline-block">Anschrift:  </h4>&ndash;&gt;-->
            <!--                        &lt;!&ndash;                        {{$store.state.brandName}}<br>&ndash;&gt;-->
            <!--                        {{$store.state.staticDisplayAbholung}}-->
            <!--                        &lt;!&ndash;                        Sudhaus<br>&ndash;&gt;-->
            <!--                        &lt;!&ndash;                        Dieplohstraße 12<br>&ndash;&gt;-->
            <!--                        &lt;!&ndash;                        59581 Warstein<br>&ndash;&gt;-->
            <!--                    </div>-->

            <!--                    <v-btn-toggle-->
            <!--                            v-model="userSelectedHeute"-->
            <!--                            tile-->
            <!--                            color="#B0916A"-->
            <!--                            group-->
            <!--                    >-->
            <!--                        <v-btn value="Heute">-->
            <!--                            Heute-->
            <!--                        </v-btn>-->

            <!--                        <v-btn value="Morgen">-->
            <!--                            Morgen-->
            <!--                        </v-btn>-->
            <!--                    </v-btn-toggle>-->


            <div class="mt-4">
              <v-btn class="primepulsing btn-df weiter"
                     :disabled="selectedAbholDatum.value.indexOf('schlossen') > -1 || !(time && time.value)"
                     @click.native.passive="finishStep2">
                Weiter
              </v-btn>
              <v-btn class="btn-df weiter grayBtn"
                     @click.native.passive="currentStep = 1">
                Zurück
              </v-btn>
            </div>
          </v-stepper-content>


          <!--                CAPTCHA STEP-->
          <v-stepper-step :complete="currentStep > 3" step="3">
            <div class="nice-title small">Bestellung bestätigen
            </div>
          </v-stepper-step>
          <v-stepper-content id="confirmation" step="3">


            <!--                    <h4 class="mt-1 mb-1">Zahlung bei Abholung:</h4>-->
            <div class="mt-4">
              <!--                        <div>Der Bestellbutton wird erst angezeigt, wenn die App fertiggestellt ist</div>-->
              <div>
                <v-btn class="mt-3 orderBtn wallet-width text-none rounded100"
                       color="green"
                       dark
                       @click.native.passive="doOrder">
                  <!--<v-icon left class="">mdi-lock-check</v-icon>-->
                  Zahlungspflichtig bestellen
                  <!--                                    v-if="captchaInput.length===4"-->
                </v-btn>
              </div>
              <orderconsent></orderconsent>
            </div>
            <div class="mt-3">
              Die Bezahlung erfolgt bei Lieferung. {{ displayPaymentMethods() }}
            </div>
            <v-btn class="mt-4 btn-df weiter grayBtn" rounded
                   @click.native.passive="currentStep = 2">
              Zurück
            </v-btn>
          </v-stepper-content>


        </v-stepper>
      </div>

    </v-container>

    <!--        <h3>TESt time = {{time}}</h3>-->

    <ssl-seal></ssl-seal>


    <div class="text-center">
      <!--      <v-btn style="margin-top: 25px" class="text-none btn-df"-->
      <!--             @click.native.passive="gotoSummary">-->
      <!--        Zurück zum Korb-->
      <!--      </v-btn>-->
      <div class="spacer-25"></div>
      <v-btn style="margin-top: 25px" class="text-none btn-mini" @click="$router.go(-1)">
        Bestellung abbrechen
      </v-btn>
    </div>

    <!--        <times-info-dialog :dialog="timesInfoDialog" @close="timesInfoDialog = false"></times-info-dialog>-->

    <div class="spacer-25"></div>

    <!--        <qsignal class="hide-md"></qsignal>-->


  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as bootstrap from '../vendor/bootstrap';
import * as xhr from '../api/xhr.js'
import * as iframe from "../iframe/iframe";
import * as util from '../vendor/util'
// import* as plausi from '../vendor/plausi'
import * as qconst from '../vendor/qconstants';

import * as firebaseUtil from '@/firebase/firebaseUtil'
// TODO activate for online

// import* as paypalUtil from '../paypal/paypalUtil'
import Orderconsent from "../components/orderconsent";

// import Qsignal from "../components/qsignal";
import SslSeal from "../components/sslSeal";
import {googlePayMerchantId} from "@/goodpay/goodpayUtil";
import {getStreetAndNumberError, isIos, isMobileOk, isPlzOk, roundToTwo} from "@/vendor/util";
import {
  action$GetDeliveryAreaInfo,
  allowedPostalCodes,
  enableGoodpay,
  enablePaypal,
  getDisplayPaymentMethods,
  PROD_ENV
} from "../vendor/qconstants";
import {getErrorDetails} from "@/util/globalErrorHandler";
import * as checkoutUtil from "@/util/deliveryMPUtil";
import {getGlobalValue, setGlobalKeyValue} from "@/util/globalState";
import {cloneMe} from "../vendor/util";
// import* as breakpoints from '../vendor/breakpoints'
// import TimesInfoDialog from "../dialogs/TimesInfoDialog";


export default {
  components: {Orderconsent, SslSeal},

  data() {
    return {
      deliveryFee: 0,
      deliveryAddressForGeoposition: null,
      minOrderAmount: 0,
      valid: true,
      showForm: true,
      initialTry: false,
      clientId: '',
      fastUnload: false,
      updateInterval: null,

      hasFd: true,

      phoneRules: [
        // v => !!v || 'Die Telefonnummer wird benötigt',
        // v => /^(?=.*\d)[\d ]+$/.test(v) || 'Dieses Feld darf nur Nummern oder Leerzeichen enthalten',
        v => isMobileOk(v) || 'Die Telefonnummer ist zu kurz'
      ],
      companyRules: [
        v => (v && v.length > 1) || 'Firmenname ist erforderlich',
      ],
      streetRules: [
        v => !getStreetAndNumberError(v) || getStreetAndNumberError(v),
      ],
      plzRules: [
        v => (v && v.length > 1) || 'Postleitzahl ist erforderlich',
      ],
      cityRules: [
        v => (v && v.length > 1) || 'Stadt ist erforderlich',
      ],

      //captcha
      captchaInput: '',
      // numberRule: v  => {
      //     if (!v.trim()) return true;
      //     if (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999) return true;
      //     return 'Number has to be between 0 and 9999';
      // },

      //abholung öffnungszeiten
      abholDatumArray: [
        {value: 'Heute'},
        {value: 'Morgen'}
      ],
      selectedAbholDatum: {value: 'Heute'},//default
      time: null, //{value:'06:45', utc:...}//produces a string i.e. 06:45
      timesToday: [
        //{
        //     value: h + ':' + minute,
        // display: 'ca. ' + h + ':' + minute + ' Uhr',
        // utc: utcValue.getTime()
        // }
      ],
      timesTomorrow: [
        //{
        //     value: h + ':' + minute,
        // display: 'ca. ' + h + ':' + minute + ' Uhr',
        // utc: utcValue.getTime()
        // }
      ],

      //Formulardaten
      name: '',
      email: '',
      kundennummer: '',
      phone: '',
      // vorname: '',
      // nachname: '',
      sameAsDeliveryAddress: true,
      invoiceAddress: {
        company: '',
        street: '',
        plz: '',
        city: '',
      },
      deliveryAddress: {
        company: '',
        street: '',
        plz: '',
        city: '',
        etage: '',
      },

      step1Error: '',

      note: '',


      // autoModel: null,
      // {
      //     displayName: '345567 Straße, Maxdorf',
      //         obj: storeObject
      // }

      // selectedStore: {
      //     // plz:'',
      //     // strasse:'',
      //     //   openingHours:
      // },
      // stores: [],
      consent: false,
      asGuest: true,

      showBar: false,
      //TODO activate for online
      showStripe: false,
      showPaypal: false,

      hasPR: false,
      wait: false,
      total: 0,

      // earlyPaymentIntentId: '',
      // earlyClientSecret: '',

      // deliveryFee: 0,
      // fee: 0,
      // minOrderAmount: 0,

      currentStep: 1,
      usecase: qconst.usecase$delivery,//initial value 'delivery',
      // daySelected: 'asap',

      // time: null, //{value:'06:45'}//produces a string i.e. 06:45
      // times: [
      //     //{ value : '06:45'}
      // ],

      // internalDaySelected: '1',

      psp: 'beiLieferung', //none, bar, stripe, paypal

      // consentA: false,
      // consentB: false,

      // deliveryAddress: {
      //     // company: '',
      //     street: '',
      //     plz: '',
      //     city: '',
      //     etage: '',
      // },


      order: {},

      //Stripe
      stripePreAuth: {},
      usingPaymentRequest: false,
      orderId: '',
      paymentIntentId: '',
      clientSecret: '',
      paymentRequestCreated: false,
      paymentRequestObject: {},
      paymentRequesttotal: 0,

      prButton: null,

      //paypal
      paypalOrderId: null,
      paypalPreAuth: {},

      // paymentIntentAmount: -1,
      paymentIntentStatus: '',
      orderNumber: '',
      uniqueOrderId: '',
      createdAt: 0,
      selectedPaymentMethodId: '',

      //only calculated:
      deliveryDate: {},
      // displayPickupDate: '',

      // timesInfoDialog: false,
      timesInfoDialog: false,
    }
  },

  watch: {
    selectedAbholDatum(newVal) {
      this.time = null;
    },
    // currentStep(newValue){
    //     if(newValue === 2){
    //
    //     }
    // }
    // sameAsDeliveryAddress(newValue) {
    //     if (this.step1Ok) {
    //         this.step1Error = '';
    //     }
    // },

    // autoModel(newValue) {
    //     if (newValue.obj) {
    //         this.$ls.set('selectedStore', JSON.stringify(newValue.obj));
    //         store.getters.selectedStore = newValue.obj;
    //         store.commit('selectedStore', util.cloneMe(newValue.ob));
    //         // this.updateMinOrderAmount();
    //     }
    // },

    // daySelected(newValue) {
    //     if (newValue === '1') {
    //         this.preselectDay1();
    //     } else if (newValue === '2') {
    //         this.preselectDay2();
    //     } else {
    //         this.time = '';
    //     }
    // },

    // consentB(newValue) {
    //     if (newValue && this.consentA) {
    //         this.currentStep = 4;
    //     }
    // },
    // consentA(newValue) {
    //     if (newValue && this.consentB) {
    //         this.currentStep = 4;
    //     }
    // },


    // time(newValue) {
    //     if (newValue && newValue.utc) {
    //         store.commit('selectedTime', util.cloneMe(newValue));
    //     }
    // }

  },

  computed: {
    // displayTomorrow() {
    //     let tomorrow = util.addDays(util.getCurrentRemoteTime(), 1);
    //     return this.$options.filters.weekDayMonth(tomorrow.getTime(), true);
    //
    //     // let d = tomorrow.toLocaleString();
    //     // return d.substring(0, d.indexOf(','));
    // },

    userSelectedHeute() {
      return this.selectedAbholDatum.value === 'Heute';
    },

    step1Ok() {
      try {
        console.log('update step1Ok ...');

        let name2Error = util.getName2Error(this.name);
        if (name2Error) {
          this.step1Error = name2Error
          return false;
        }

        this.email = util.removeSpaces(this.email);
        if (!util.isEmailOk(this.email)) {
          this.step1Error = 'Die E-Mail Addresse ist ungültig';
          return false;
        }

        try {
          if (!isMobileOk(this.phone)) {// this.phone || this.phone.length < 10 || !(this.$refs.phone.valid && !this.$refs.phone.hasError)) {
            this.step1Error = 'Die eingegebene Mobilnummer ist ungültig';
            return false;
          }
        } catch (e) {
          console.log('FIXME phone error: ' + e.message);
          return false;
        }

        //deliveryAddress
        //street
        let street = this.deliveryAddress.street;
        if (getStreetAndNumberError(street)) {
          this.step1Error = getStreetAndNumberError(street);
          return false;
        }

        //validate plz
        if (!this.deliveryAddress.plz || this.deliveryAddress.plz.length == 0) {
          this.step1Error = 'Die Postleitzahl ist erforderlich';
          return false;
        }
        let plz = util.removeSpaces(this.deliveryAddress.plz);
        if (!isPlzOk(plz)) {
          this.step1Error = 'Die Postleitzahl muss eine Nummer sein';
          return false;
        }
        if (plz.length < 4) {
          this.step1Error = 'Die Postleitzahl ist zu kurz';
          return false;
        }

        //city
        if (!this.deliveryAddress.city || this.deliveryAddress.city.length < 3) {
          this.step1Error = 'Der Ort ist erforderlich';
          return false;
        }

        if (!this.deliveryAddress) {
          //invoiceAddress
          if (this.deliveryAddress?.street?.length < 4) {
            this.step1Error = 'Die Straße ist erforderlich';
            return false;
          }

          if (
              this.deliveryAddress?.street?.length > 0 &&
              !/\b\d+[a-zA-Z]?\b/.test(this.deliveryAddress.street)
          ) {
            this.step1Error = 'Die Hausnummer fehlt';
            return false;
          }
          // if (this.deliveryAddress?.street?.length > 0 && (/\d/.test(this.deliveryAddress.street) === false)) {
          //   this.step1Error = 'Die Hausnummer fehlt';
          //   return false;
          // }

          //validate plz
          if (this.deliveryAddress?.plz?.length < 4) {
            this.step1Error = 'Die Postleitzahl ist erforderlich';
            return false;
          }
          let plz = this.deliveryAddress?.plz?.trim();
          if (isPlzOk(plz) === false) {
            this.step1Error = 'Die Postleitzahl muss eine Nummer sein';
            return false;
          }
          if (plz.length < 4) {
            this.step1Error = 'Die Postleitzahl ist zu kurz';
            return false;
          }

          //city
          if (this.deliveryAddress?.city?.length < 3) {
            this.step1Error = 'Der Ort ist erforderlich';
            return false;
          }
        }

      } catch (e) {
        console.log('error in step1Ok: ' + e.message);
      }
      this.step1Error = '';
      return true;
    },

    paymentMethods() {
      return store.getters.paymentMethods;
    },

    // autocompleteStores() {
    //     let allstores = util.cloneMe(store.getters.stores);
    //     let model = [];
    //     for (let store of allstores) {
    //         model.push(
    //             {
    //                 displayName: store.strasse + ', ' + store.plz + ' ' + store.ort,
    //                 obj: store
    //             });
    //     }
    //     return model;
    // },

    // displayLieferwunsch() {
    //     if (this.daySelected === 'asap') {
    //         return 'So schnell wie möglich';
    //     } else if (this.daySelected === '1') {
    //         return 'Vorbestellung Heute';
    //     } else if (this.daySelected === '2') {
    //         return 'Vorbestellung Morgen';
    //     }
    //     return '';
    // }
  },

  beforeMount() {
    this.checkEnter();

    let itemsString = JSON.stringify(store.getters.cartItems);
    try {
      let itemsHash = new Hashes.SHA256().hex(itemsString);
      if (itemsHash === this.$ls.get('lastItemsHash')) {
        console.log('use the same clientId');
        // this.$ls.set('clientId', util.generateClientId());
      } else {
        console.log('generate a new clientId');
        this.$ls.set('lastItemsHash', itemsHash);
        this.$ls.set('clientId', util.generateClientId());
      }
    } catch (e) {
    }
  },

  // mounted() {
  // },

  // mounted() {
  //     this.init();
  // },

  created() {
    ebus.$on('cb-geoPositionCeckoutDelivery', (geopositionResult) => {
      console.log('received geoposition callback');
      this.finishStep1b(geopositionResult);
    });
    ebus.$on('appconfigLoaded', () => {
      // if (this.timesToday.length === 0) {
      this.init();
      // }
    });
  },

  mounted() {
    if (!bootstrap.getBtaste()) {
      window.location.reload();
      return;
    }
    // if (store.state.fromWidget) {
    //     store.commit('showLoading', true);
    // }
    ebus.$emit('loadAppconfig');
    store.state.hideScroll = true;
    this.captchaInput = '';
    if (this.checkEnter()) {
      // util.jumpToTop();
      this.init();
      // firebaseUtil.gevent('begin_checkout', {
      //     currency: 'EUR',
      //     value: this.total,
      //     items: util.cloneMe(firebaseUtil.getGitemsFromCart(store.getters.cartItems))
      // });
    }
    // store.commit('showLoading', false);

    this.updateInterval = setInterval(() => {
      ebus.$emit('loadAppconfig');
    }, 30 * 1000);

    //TODO activate for online only for online payment
    // if (this.$ls.get('continueCheckout', false)) {
    //     this.$ls.remove('continueCheckout');
    //     this.finishStep1();
    //     if (this.time !== null) {
    //         let ea = this.calcEarliestAbholung();
    //         if (this.time.utc >= ea.getTime()) {
    //             //already selected time is till valid, so lets go to payment directly
    //             setTimeout(() => {
    //                 this.psp = 'credit';
    //                 this.finishStep2();
    //             }, 200);
    //         } else {
    //             this.time = null;
    //         }
    //     }
    // }

  },

  destroyed() {
    this.safeUnload();

    util.clearEvents([
      'appconfigLoaded',
    ]);


    store.commit('removeSpecialCartItem', 'specialUniqueDeliveryFee');

    store.state.hideScroll = false;
    // this.earlyClientSecret = '';
    this.clientSecret = '';
    this.order = {};
    this.usingPaymentRequest = false;
    this.paymentIntentId = '';
    this.stripePreAuth = {};
    this.paypalPreAuth = {};
    // document.getElementById('paypal-button-container').innerHTML = '';
    this.currentStep = 1;

    if (this.prButton) {
      console.log('??? unmount prButton...');
      // this.prButton.unmount('#payment-request-button');
    }

    // this.paymentRequestCreated = false;

    store.commit('removeSpecialCartItem', 'specialUniqueOnlineServiceFee');
    store.commit('removeSpecialCartItem', 'specialUniqueDeliveryFee');

    util.clearTheInterval(this.updateInterval);
  },

  methods: {
    displayPaymentMethods() {
      return getDisplayPaymentMethods(true);
    },
    refreshForm() {
      if (isIos()) {
        this.showForm = false;
        setTimeout(() => {
          this.showForm = true;
        }, 400);
      }
    },
    resetValidation() {
      this.$nextTick(() => {
        this.$refs.deliveryMpDataForm.resetValidation();
        this.refreshForm()//Bugfix for https://github.com/vuetifyjs/vuetify/issues/11942
      });
    },
    validate() {
      try {
        return this.$refs.deliveryMpDataForm.validate()
      } catch (e) {
        return false;
      }
    },
    phoneKeydown(e) {
      util.phoneKeydown(e);
    },
    hideToolbar() {
      store.commit('hideToolbar', true);
    },
    unhideToolbar() {
      store.commit('hideToolbar', false);
    },
    // clickRadio() {
    //     util.delayScroll('paymentRadios');
    // },
    // preselectCreditCard() {
    //     let pMethods = this.paymentMethods;
    //     // let pMethods =  util.cloneMe(store.getters.paymentMethods);
    //     if (pMethods && pMethods.length > 0) {
    //         this.selectMethod(pMethods[0]);
    //     }
    // },

    showLieferzeiten() {
      this.timesInfoDialog = true;
    },

    // handleScrollingInStep2() {
    //     util.delayScroll('hintStep2');
    // },

    handleScrollingInStep3() {
      // util.delayScroll('paymentRadios');
    },

    // attachPaymentMethodToStripeCustomer(_paymentMethodId, cb) {
    //     let msg = {
    //         action: qconst.action$AttachPaymentMethodToStripe,
    //         uid: bootstrap.getBtaste(),
    //         stripeCustomerId: store.state.stripeCustomerId,
    //         paymentMethodId: _paymentMethodId,
    //     };
    //     // if (firebaseUtil.getUser()) {
    //     //     msg.fuid = firebaseUtil.getUser().uid
    //     // }
    //     xhr.xhrSend(true, msg, (reply) => {
    //         if (reply.ok) {
    //             console.log('??? reloadBuyersProfile...');
    //             setTimeout(() => {
    //                 ebus.$emit('pullBuyersProfile');
    //             }, 1200);
    //         } else {
    //             console.log('??? reply of  action$AttachPaymentMethodToStripe not ok; ' +
    //                 'maybe the payment method already exits ');
    //             // this.notifyError('Unerwarteter Fehler', 'Bitte versuche es erneut');
    //         }
    //         cb(true);
    //     }, (err) => {
    //         this.notifyError('Unerwarteter Fehler', err);
    //         cb(false);
    //     });
    // },

    updateTotal() {
      if (this.deliveryFee > 0) {
        let item = {
          id: 'specialUniqueDeliveryFee',
          num: '',
          posId: '5007',
          // delay: this.selectedCat.delay,
          cartItemId: util.generateClientId(),
          isOffer: false,//!!(size.offerId), //offers and cartItems ar always size specific
          type: qconst.type$generic,
          nameToDisplay: 'Liefergebühr',//itemClone.nameDE,
          description: '',// + itemClone.descriptionDE,
          // days: itemClone.days,
          notes: '',
          // gramm: itemClone.gramm,
          // unikat: !!(itemClone.unikat),
          sizePrice: 0 + this.deliveryFee,// sizePrice,
          sumOfExtras: 0,// sizePrices.sumOfExtras,// this.total - (size.price * size.aaaCount),
          itemTotal: 0 + this.deliveryFee,//sizePrices.sizeTotal + sizePrices.sumOfExtras,
          count: 1,
          vol: '',//size.vol,
          extras: [
            // {name:'',price:0}
          ],
          extrasToDisplay: [], //['eins', 'zwe' ] //or empty array
          variantsSelected: [], //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
          stylesSelected: [] //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
        };
        store.commit('addItemToCart', {
          item: item, addSilent: true
        });
      }

      this.total = 0 + roundToTwo(store.getters.payerSum) - this.totalSavedByDiscounts;//+ this.deliveryFee;

      // if (this.usecase === 'delivery') {
      //     // let fee = 0;
      //     try {
      //         this.total = store.getters.payerSum + this.deliveryFee;
      //     } catch (e) {
      //         console.log('error updating total: ' + e);
      //     }
      // } else
      // if (this.usecase === qconst.usecase$delivery) {
      //     // let fee = 0;
      //     try {
      //         this.total = 0 + roundToTwo(store.getters.payerSum) + store.state.deliveryFee;
      //     } catch (e) {
      //         console.log('error updating total: ' + e);
      //     }
      // }
      // if (this.usecase === qconst.usecase$takeAway) {
      //     // let fee = 0;
      //     try {
      //         this.total = store.state.takeAwayPayerSum;//+ store.getters.selectedStore.fee;
      //     } catch (e) {
      //         console.log('error updating total: ' + e);
      //     }
      // }
    },

    // lazyCreateEarlyPaymentIntent() {
    //     if (this.earlyClientSecret.length > 0) {
    //         return;
    //     }
    //     let msg = {
    //         action: qconst.action$StripeCreateEarlyPaymentIntent,
    //         restaurantId: store.state.restaurantData.restaurantId,
    //         amount: this.total,
    //         userInfo: util.cloneMe(store.state.user),
    //         stripeCustomerId: store.state.stripeCustomerId,
    //         // paymentMethodId: this.selectedPaymentMethodId
    //     };
    //     xhr.xhrSend(true, msg, (reply) => {
    //         if (reply.ok) {
    //             let paymentIntentId = reply.paymentIntentId;
    //             let clientSecret = reply.clientSecret;
    //             console.log('??? early paymentIntentId=' + paymentIntentId);
    //             console.log('??? early clientSecret=' + clientSecret);
    //             this.$nextTick(() => {
    //                 let status = reply.status;
    //                 // this.paymentIntentAmount = msg.amount;
    //                 this.earlyPaymentIntentId = paymentIntentId;
    //                 this.earlyClientSecret = clientSecret;
    //                 // this.paymentIntentStatus = status;
    //                 // this.orderNumber = reply.orderNumber;
    //                 // this.uniqueOrderId = reply.uniqueOrderId;
    //                 // this.createdAt = reply.createdAt; //server-side createdAt
    //
    //                 console.log('???status of early paymentIntent: ' + status);//requires_payment_method
    //
    //                 this.createPaymentRequest();
    //
    //                 // if (status === 'requires_action') {
    //                 //     this.handleRequiresAction();
    //                 // } else if (status === 'requires_capture') {
    //                 //     // this.notifyInfo('Die Zahlung wurde erfolgreich autorisiert');
    //                 //     this.saveOrder();
    //                 // } else {
    //                 //     this.notifyError('Unbekannter Status: ', status);
    //                 // }
    //             });
    //         }
    //     }, (err) => {
    //         console.log('??? error creating early intent: ' + err);
    //     })
    // },

    lazyCreatePaymentRequest() {
//                 if (!navigator.onLine) {
//                     this.notifyError('Warnung', 'Du hast keine Internetverbindung!');
//                     return;
//                 }
//                 // if (this.paymentRequestCreated) {
//                 //     //Can only create one Element of type paymentRequestButton.
//                 //     return;
//                 // }
//
//                 // if (this.earlyClientSecret.length === 0) {
//                 //     //PR is not possible hen there is no early paymentIntent / clientSecret
//                 //     return;
//                 // }
//
//                 //PayPal
//                 try {
//                     //https://developer.paypal.com/docs/api/orders/v2/#orders_create
//                     let payPalTxDetails = {
//                         intent: 'AUTHORIZE',
//                         // intent: 'authorize',
//                         payer: {
//                             name: {
//                                 given_name: '',
//                                 surname: ''
//                             },
//                             //@see https://developer.paypal.com/docs/api/orders/v2/#definition-phone_with_type.phone
//                             // phone: {
//                             //     phone_type: 'MOBILE',
//                             //     phone_number: {
//                             //         national_number: firebaseUtil.getUser().phoneNumber
//                             //     }
//                             // }
//                         },
//                         //https://developer.paypal.com/docs/api/orders/v2/#definition-purchase_unit_request
//                         purchase_units: [{
//                             description: 'Bestellung bei ' + store.getters.storeName,
//                             // custom_id:'',
//                             amount: {
//                                 currency_code: 'EUR',
//                                 value: '' + roundToTwo(this.total),//'1.00'
//                                 breakdown: {
//                                     item_total: {
//                                         currency_code: 'EUR',
//                                         value: '' + roundToTwo(this.total),
//                                     },
//                                     handling: {
//                                         currency_code: 'EUR',
//                                         value: '0'
//                                     },
//                                     // shipping_discount: {
//                                     //     currency_code: 'EUR',
//                                     //     value: '0'
//                                     // }
//                                 }
//                             },
//                             // payee: {
//                             //     // email_address: firebaseUtil.getUser().email,
//                             //     merchant_id: paypalUtil.sellerAccountId,
//                             // },
//                             // shipping
//
//
//                             // "items": [
//                             //     {
//                             //         "name": "Levis 501 Selvedge STF",
//                             //         "unit_amount": {
//                             //             "currency_code": "EUR",
//                             //             "value": "25.00"
//                             //         },
//                             //         "quantity": "1"
//                             //
//                             //     }
//                             // ],
//                             // "custom_id": "custom_value_{{$timestamp}}",
//                             // "invoice_id": "invoice_number_{{$timestamp}}",
//                             // "soft_descriptor": "Payment Camera Shop"
//
//
//                             // description: 'Gesamtbetrag',
//                             // // custom_id: firebaseUtil.getUser().uid,
//                             // soft_descriptor: '' + store.getters.storeName,
//                             // final_capture: false
//                         }],
//                         application_context: {
//                             brand_name: '' + store.state.brandName,
//                             shipping_preference: 'NO_SHIPPING'
//                             // shipping_preference: 'SET_PROVIDED_ADDRESS'
//                         },
//                         shipping_type: this.usecase === qconst.usecase$delivery ? 'SHIPPING' : 'PICKUP'
//                     };
//
//                     if (this.name.length > 0) {
//                         let name = '' + this.name;
//                         let vorname = name.substring(0, name.indexOf(' '));
//                         let nachname = name.substring(name.indexOf(' '), name.length);
//                         payPalTxDetails.payer.name = {
//                             given_name: vorname,
//                             surname: nachname,
//                         };
//                     }
//
//
//                     // if (this.usecase === qconst.usecase$delivery || this.usecase === qconst.usecase$takeAway || this.usecase === qconst.usecase$taxi) {
//                     //     payPalTxDetails.application_context.shipping_preference = 'SET_PROVIDED_ADDRESS';
//                     let name = '';
//                     let address = {};
//                     let da = this.sameAsDeliveryAddress === true ? util.cloneMe(this.invoiceAddress) : util.cloneMe(this.deliveryAddress);
//                     //     if (this.usecase === qconst.usecase$takeAway) {
//                     //// S2S = ship to store
//                     //         name = 'S2S ' + store.getters.selectedStore.strasse + ' ' + store.getters.selectedStore.ort;
//                     //         address.street = '' + store.getters.selectedStore.strasse.trim();
//                     //         address.city = '' + store.getters.selectedStore.ort.trim();
//                     //         address.plz = '' + store.getters.selectedStore.plz.trim();
//                     //     } else {
//                     name = '' + this.name;
//                     address.street = da.street.trim();
//                     address.city = da.city.trim();
//                     address.plz = da.plz.trim();
//                     //     }
//
//                     // payPalTxDetails.purchase_units[0].shipping = {
//                     //     name: {
//                     //         full_name: name
//                     //     },
//                     //     // company: '' + this.deliveryAddress.company.trim(),
//                     //     // street: '' + this.deliveryAddress.street.trim(),
//                     //     // plz: '' + this.deliveryAddress.plz.trim(),
//                     //     // city: '' + this.deliveryAddress.city.trim(),
//                     //     address: {
//                     //         address_line_1: address.street,
//                     //         // address_line_2: '' + this.deliveryAddress.street.trim(),
//                     //         admin_area_2: address.city,
//                     //         // admin_area_1: '' + this.deliveryAddress.city.trim(),
//                     //         postal_code: address.plz,
//                     //         // address_line_1: '' + this.deliveryAddress.street.trim(),
//                     //         // // address_line_2: '' + this.deliveryAddress.street.trim(),
//                     //         // admin_area_2: '' + this.deliveryAddress.city.trim(),
//                     //         // // admin_area_1: '' + this.deliveryAddress.city.trim(),
//                     //         // postal_code: '' + this.deliveryAddress.plz.trim(),
//                     //         country_code: 'DE'
//                     //     }
//                     // }
//                     // } else {
//                     //     payPalTxDetails.application_context.shipping_preference = 'NO_SHIPPING';
//                     // }
//
//
//                     console.log('Paypal amount: ' + payPalTxDetails.purchase_units[0].amount.value);
//
//                     let _this = this;
//                     let _uid = bootstrap.getBtaste();
//
//                     //mount paypal button
//                     console.log('mount PayPal button...');
//                     //clear the button container first
//                     document.getElementById('paypal-button-container').innerHTML = '';
//                     // let cont = document.getElementById('paypal-button-container');
//                     // console.log('paypal-button-container = ',cont);
//                     // cont.innerHTML = '';
//                     paypal.Buttons({
//                         // style: {
//                         //     layout: 'horizontal',
//                         // },
//                         // Set up the transaction after the user clicked the PayPal button
//                         createOrder: function () {
//                             // createOrder: function (data, actions) {
//                             store.commit('showLoading', true);
//                             console.log('paypal createOrder... ');
//
//                             let msg = {
//                                 action: qconst.action$CreatePayPalOrder,
//                                 order: payPalTxDetails
//                             };
//
//                             return new Promise((resolve, reject) => {
//                                 xhr.xhrSend(true, msg, (res) => {
//                                     console.log('paypal createOrder res: ', JSON.stringify(res));
//                                     if (res.ok && res.data && res.data.id) {
//                                         console.log('paypal order created with orderId: ' + res.data.id);
//                                         _this.$nextTick(function () {
//                                             _this.paypalOrderId = res.data.id;
//                                         });
//                                         resolve(res.data.id); //orderId
//                                     } else {
//                                         console.log('paypal error in createOrder');
//                                         reject();
//                                     }
//                                 }, (err) => {
//                                     console.log('paypal createOrder err: ' + err.message);
//                                     reject('Error creating order');
//                                 });
//                             });
//
//
//                             // return actions.order.create(payPalTxDetails
//                             //     //     {
//                             //     //     purchase_units: [{
//                             //     //         amount: {
//                             //     //             value: '0.01'
//                             //     //         }
//                             //     //     }]
//                             //     // }
//                             // );
//                         },
//                         // Finalize the transaction
//                         // onApprove: function(data, actions) {
//                         //     return actions.order.capture().then(function(details) {
//                         //         // Show a success message to the buyer
//                         //         alert('Transaction completed by ' + details.payer.name.given_name + '!');
//                         //     });
//                         // }
//
//                         // createOrder(data, actions) {
//                         //     // This function sets up the details of the transaction, including the amount and line item details.
//                         //     return actions.order.create(payPalTxDetails);
//                         // },
//                         onCancel: function () {
//                             store.commit('showLoading', false);
//                         },
//
//                         onApprove: function (data, actions) {
//                             store.commit('showLoading', true);
//                             console.log('PayPal onApprove...');
//                             /*
//                             {orderID: "7A3177749P8522230", payerID: "5JJEW997VEN9G", facilitatorAccessToken: "A21AAHoer7Hkutbn5_oOD0PrE0KoB70gl3dNjwCEzvHvtRC_pGRMMtvy8xJL23D7hm1D3xi2m5fo4wNyHWb6icbo_xipQDQTA"}
// orderID: "7A3177749P8522230"
// payerID: "5JJEW997VEN9G"
// facilitatorAccessToken: "A21AAHoer7Hkutbn5_oOD0PrE0KoB70gl3dNjwCEzvHvtRC_pGRMMtvy8xJL23D7hm1D3xi2m5fo4wNyHWb6icbo_xipQDQTA..."
// }
//                            */
//                             /*
//                             {order: {…}, payment: null, subscription: {…}, restart: ƒ, redirect: ƒ}
// order: {capture: ƒ, authorize: ƒ, patch: ƒ, get: ƒ}
// payment: null
// subscription: {get: ƒ, activate: ƒ}
// restart: ƒ crossDomainFunctionWrapper()
// redirect: ƒ crossDomainFunctionWrapper()
//                            */
//
//                             //First create the uniqueOrderId and store it as invoice_id to the paypal order
//                             if (!_this.paypalOrderId || _this.paypalOrderId.length === 0) {
//                                 console.log('paypalOrderId missing');
//                                 return;
//                             }
//
//                             console.log('!!!! paypal actions = ', actions);
//                             let approveId = actions.id;
//                             console.log('paypal actions.id = ' + actions.id);
//
//
//                             let msg = {
//                                 action: qconst.action$PaypalCreatePaypalInvoiceId, //patches the invoice_id
//                                 paypalOrderId: '' + _this.paypalOrderId,
//                                 amount: _this.total, //double value
//                                 // paypalPreAuth: _paypalPreAuth,
//                                 // storeId: store.getters.restId,
//                                 // sellerAccountId: '' + paypalUtil.sellerAccountId,
//                             };
//                             if (!_this.asGuest) {
//                                 msg.fuid = firebaseUtil.getFuid();
//                             }
//                             console.log('CreatePaypalInvoiceId message: ' + JSON.stringify(msg));
//
//                             xhr.xhrSend(true, msg, (res) => {
//                                 console.log('paypal CreatePaypalInvoiceId response: ', JSON.stringify(res));
//                                 if (res.ok && res.data) {
//                                     _this.paypalPreAuth = res.data;
//                                     //contains
//                                     // paypalOrderId,orderNumber, uniqueOrderId, createdAt,amount
//
//                                     //Now we have a uniqueOrderNumber, createdAt in the preAuth
//                                     // and the invoice_id is already set inside the paypal order
//
//                                     // PayPal Authorize the transaction
//                                     actions.order.authorize().then(function (authorization) {
//
//                                         console.log('paypal authorization: ', JSON.stringify(authorization));
//
//                                         // Get the authorization id
//                                         var authorizationID = authorization.purchase_units[0]
//                                             .payments.authorizations[0].id;
//
//                                         console.log('!!!! paypal authorizationID: ' + authorizationID);
//
//                                         //append authorizationID to the preAuth
//                                         _this.paypalPreAuth.paypalAuthId = authorizationID;
//                                         // _this.paypalPreAuth.sellerAccountId = '' + paypalUtil.sellerAccountId;
//                                         // console.log('??? _uid '+_uid);
//                                         // console.log('??? _this.asGuest '+!!_this.asGuest);
//                                         _this.paypalPreAuth.uid = _uid;
//                                         if (!_this.asGuest) {
//                                             _this.paypalPreAuth.fuid = firebaseUtil.getFuid();
//                                         }
//                                         // _this.paypalPreAuth.fuid = (_this.asGuest === true ? _uid : firebaseUtil.getUser().uid);
//                                         // _this.approveId = approveId; // is always null??
//
//                                         //paypalPreAuth contains
//                                         // paypalOrderId,orderNumber,uniqueOrderId,createdAt,amount,paypalAuthId,sellerAccountId,fuid
//
//                                         //Call the server to store the preAuth
//                                         console.log('savePaypalPreAuth: ' + JSON.stringify(_this.paypalPreAuth));
//
//                                         //Now save the order and the preAuth
//                                         _this.$nextTick(() => {
//                                             _this.saveOrder(!!_this.clientId);
//                                         });
//
//                                         // Call your server to validate and capture the transaction
//                                         // return fetch('/paypal-transaction-complete', {
//                                         //     method: 'post',
//                                         //     headers: {
//                                         //         'content-type': 'application/json'
//                                         //     },
//                                         //     body: JSON.stringify({
//                                         //         orderID: data.orderID,
//                                         //         authorizationID: authorizationID
//                                         //     })
//                                         // });
//                                     }).catch(err => {
//                                         console.log('Error authorize paypal payment: ' + err.message);
//                                         _this.notifyError('PayPal Autorisierung fehlgeschlagen');
//                                         store.commit('showLoading', false);
//                                     });
//                                 } else {
//                                     console.log('CreatePaypalInvoiceId response err');
//                                     _this.notifyError('PayPal Verarbeitung wurde unterbrochen');
//                                     store.commit('showLoading', false);
//                                 }
//                             }, (err) => {
//                                 console.log('paypalPreAuth err: ' + err.message);
//                                 _this.notifyError('PayPal Verbindungsfehler');
//                                 store.commit('showLoading', false);
//                             });
//
//
//                         }
//                     }).render('#paypal-button-container');//mount paypal button
//                 } catch (e) {
//                     this.notifyError('Internet Verbindungsfehler P');
//                     console.log('PayPal PaymentRequest error: ' + e.message);
//                     ebus.$emit('forceReload');
//                     return false;
//                 }
//
//
//                 //Stripe
//                 try {
//
//                     if (!this.paymentRequestCreated) {
//                         this.paymentRequestObject = stripeUtil.platform.paymentRequest({
//                             country: 'DE',
//                             currency: 'eur',
//                             total: {
//                                 label: 'Gesamtbetrag',
//                                 amount: parseInt((this.total*100).toFixed(0)),
//                             },
//                             requestPayerName: false,
//                             requestPayerEmail: false,
//                             requestShipping: false
//                         });
//                         //remember the total of the paymentRequest to be able to detect changes of the total
//                         this.paymentRequestTotal = (0 + this.total);
//                     } else {
//                         if (this.total !== this.paymentRequestTotal) {
//                             //update paymentRequest
//                             this.paymentRequestObject.update({
//                                 total: {
//                                     label: 'Gesamtbetrag',
//                                     amount: parseInt((this.total*100).toFixed(0)),
//                                 }
//                             });
//                             this.paymentRequestTotal = (0 + this.total);
//                         }
//                     }
//
//                     const paymentRequest = this.paymentRequestObject;
//
//                     if (!this.paymentRequestCreated) {
//                         console.log('??? create PaymentRequest...');
//                         let _prButton = stripeUtil.platformElements.create('paymentRequestButton', {
//                             paymentRequest,
//                             style: {
//                                 paymentRequestButton: {
//                                     // type: 'buy',//'default' | 'donate' | 'buy', // default: 'default'
//                                     theme: 'dark', // 'dark' | 'light' | 'light-outline', // default: 'dark'
//                                     height: '55px', // default: '40px', the width is always '100%'
//                                 },
//                             },
//                         });
//                         this.$nextTick(() => {
//                             this.prButton = _prButton;
//                             this.paymentRequestCreated = true;
//                         });
//
//                     }
//
//                     //mount() must be called on every activated
//                     (async () => {
//                         // Check the availability of the Payment Request API first.
//                         console.log('prButton: canMakePayment()...');
//                         const result = await paymentRequest.canMakePayment();
//                         //Returns a Promise that resolves with a payload if a browser payment API is available.
//                         // If no API is available, it resolves with null. The resolution object has these properties:
//                         console.log('??? canMake Result = ', result);
//                         if (result) {
//                             console.log('??? canMake PR => mount pr button...');
//                             this.prButton.mount('#payment-request-button');
//                         } else {
//                             console.log('??? can not make PR');
//                             document.getElementById('payment-request-button').style.display = 'none';
//                         }
//
//                         this.$nextTick(() => {
//                             this.hasPR = result;
//                             // this.psp = 'stripe'; //preselect stripe
//                         });
//                     })();
//
//                     paymentRequest.on('paymentmethod', async (ev) => {
//
//                         console.log('??? ev paymentMethodId: ' + ev.paymentMethod.id);
//
//                         if ('id' in ev.paymentMethod) {
//                             this.selectedPaymentMethodId = ev.paymentMethod.id;
//                             this.attachPaymentMethodToStripeCustomer(this.selectedPaymentMethodId, (ok) => {
//                                 if (ok) {
//                                     store.commit('showLoading', true);
//                                     this.$nextTick(() => {
//                                         this.usingPaymentRequest = true;
//                                         this.createStripePaymentIntent();
//                                     });
//                                     ev.complete('success');
//                                 } else {
//                                     store.commit('showLoading', false);
//                                     this.$nextTick(() => {
//                                         this.usingPaymentRequest = false;
//                                     });
//                                     ev.complete('fail');
//                                 }
//                             });
//                         } else {
//                             ev.complete('fail');
//                         }
//
//
//                         // const {
//                         //     error: confirmError,
//                         //     // paymentIntent,
//                         // } = await stripeUtil.platform.confirmPaymentIntent(this.earlyClientSecret, {
//                         //     payment_method: ev.paymentMethod.id,
//                         // });
//                         //
//                         // if (confirmError) {
//                         //     // Report to the browser that the payment failed, prompting it to
//                         //     // re-show the payment interface, or show an error message and close
//                         //     // the payment interface.
//                         //     console.log('??? paymentmethod confirmError');
//                         //     ev.complete('fail');
//                         //     // this.notifyError('Zahlvorgang abgebrochen');
//                         // } else {
//                         //     console.log('??? paymentmethod success');
//                         //     // Report to the browser that the confirmation was successful, prompting
//                         //     // it to close the browser payment method collection interface.
//                         //     ev.complete('success');
//                         //
//                         //     //Authorization was successfull, so tell the server to store the intent to stripePreAuhs
//                         //     //TODO
//                         //
//                         //     // Let Stripe.js handle the rest of the payment flow.
//                         //     //the method handleCardPayment is what would handle 3DS
//                         //
//                         //     /*
//                         //     .................................
//                         //     `handleCardPayment`will handle SCA / the `requires_action` state for you, I don't think there is
//                         //     any case where after handleCardPayment, you would be in `requires_action`
//                         //     .................................
//                         //     */
//                         //
//                         //     const {paymentIntent, error} = await stripeUtil.connectedAccount.handleCardPayment(this.earlyClientSecret);
//                         //     if (error) {
//                         //         // The payment authorization failed -- ask your customer for a new payment method.
//                         //         this.notifyError('Authorisierung fehlgeschlagen');
//                         //         console.log('??? error:  ' + JSON.stringify(error));
//                         //     } else {
//                         //         // The payment authorization has succeeded.
//                         //         this.notifyInfo('Authorisierung erfolgreich');
//                         //
//                         //         //now tell the server to store the paymentIntent to the database
//                         //
//                         //
//                         //         //now save the order
//                         //
//                         //
//                         //     }
//                         // }
//                     });
//                 } catch (e) {
//                     this.notifyError('Internet Verbindungsfehler S');
//                     console.log('Stripe PaymentRequest error: ' + e.message);
//                     ebus.$emit('forceReload');
//                     return false;
//                 }
//                 return true;
    },

    // clickDelivery() {
    //     this.usecase = 'delivery';
    //     this.updateTotal();
    //     util.delayScroll('checkData');
    // },

    // clickTakeAway() {
    //     this.usecase = 'takeAway';
    //     this.updateTotal();
    //     util.delayScroll('checkData');
    // },

    checkEnter() {
      try {
        if (
            // (!this.$ls.get('asGuest',true) && store.getters.loggedIn === false) ||
            store.getters.cartItems.length === 0 ||
            !store.getters.orderingEnabled
        ) {
          ebus.$emit('gotoStart');
          return false;
        }
        return true;
      } catch (e) {
        console.log('Error in checkEnter...');
        ebus.$emit('gotoStart');
        return false;
      }
    },

    // updateDeliveryAddressInAccount() {
    //     let da = util.cloneMe(this.deliveryAddress);
    //     // da.company.trim();
    //     da.street.trim();
    //     da.plz.trim();
    //     da.city.trim();
    //     da.etage.trim();
    //
    //     if (da && da.plz && da.street && da.street.length > 0) {
    //         let upsertMsg = {
    //             action: qconst.action$UpsertAppUser,
    //             fuid: firebaseUtil.getUser().uid,
    //             deliveryAddress: da,
    //         };
    //         xhr.xhrSend(true, upsertMsg, (response) => {
    //             console.log('deliveryAddress updated in account')
    //         }, (err) => {
    //             console.log('error updating deliveryAddress in account: ' + e.message);
    //         });
    //         this.$ls.set('deliveryAddress', JSON.stringify(da));
    //     }
    // },

    preselectFields() {
      try {
        let fd = this.$ls.get('formData') || {};
        let ia = this.$ls.get('invoiceAddress') || {};
        let da = this.$ls.get('deliveryAddress') || {};
        this.hasFd = !util.isEmptyObject(fd);
        if (this.hasFd) {
          if (this.name.length === 0) {
            this.name = fd.name;
            this.email = util.sanitizeEmail(fd.email);
            this.phone = fd.phone;
            // this.kundennummer = fd.kundennummer;
          }
          if (ia?.street?.length) {
            this.invoiceAddress = ia;
          }
          if (da?.street?.length) {
            this.deliveryAddress = da;
          }
          if (fd.note) {
            this.note = fd.note;
          }
        } else {
          // this.invoiceAddress.plz = store.state.defaultPlz;//default PLZ
          // this.invoiceAddress.city = store.state.defaultCity;//default City
        }
        let fbUser = firebaseUtil.getUser();
        if (fbUser) {
          if (fbUser.displayName) {
            this.name = fbUser.displayName;
          }
          if (fbUser.email) {
            this.email = fbUser.email;
          }
          if (fbUser.phoneNumber) {
            this.phone = fbUser.phoneNumber;
          }
        }
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('error in load form: ' + e.message));
      }
    },

    init() {
      try {
        this.currentStep = 1;
        this.consent = false;

        this.showBar = enableGoodpay;
        this.showStripe = enableGoodpay;
        // this.showWallet = !!store.state.appContext.stripe;
        this.showPaypal = enablePaypal;

        this.psp = 'beiLieferung'; // default

        this.initTimesArray();

        //preselect time
        this.preselectTime();


        // this.initTimesArray();
        //
        // //preselect time
        // let st = store.getters.selectedTime;
        // for (let t of this.times) {
        //     if (t.value === st.value) {
        //         this.time = t;
        //         break;
        //     }
        // }

        //init stores
        // this.stores = util.cloneMe(store.getters.stores);

        // //preslect autoModel the store from the local store
        // let lsSelectedStore = this.$ls.get('selectedStore');
        // if (lsSelectedStore) {
        //     let lss = JSON.parse(lsSelectedStore);
        //     if (lss.plz && lss.strasse) {
        //         store.getters.selectedStore = util.cloneMe(lss);
        //         this.autoModel = {
        //             displayName: lss.strasse + ', ' + lss.plz + ' ' + lss.ort,
        //             obj: lss
        //         };
        //     }
        // }

        //preselect psp
        // if (this.showBar) {
        //     this.psp = 'bar';
        // } else if (this.showStripe) {
        //     this.psp = 'stripe';
        // } else if (this.showPaypal) {
        //     this.psp = 'paypal';
        // }

        //fill name, email, phone, invoiceAddress and deliveryAddress as possible
        // if (!this.asGuest) {
        //     let user = firebaseUtil.getUser();
        //     if (user) {
        //         if (user.displayName && user.displayName.indexOf(' ') > 0) {
        //             this.name = user.displayName;
        //         }
        //         this.email = user.email;
        //         this.phone = user.phoneNumber;
        //         // //init vorname und nachname
        //         // this.vorname = user.displayName.substring(0, user.displayName.indexOf(' '));
        //         // this.nachname = user.displayName.substring(user.displayName.indexOf(' '), user.displayName.length);
        //     }
        // }

        this.preselectFields();

        // if(this.invoiceAddress.street.length === 0){
        //     //preselect company
        //     let _company = this.$ls.get('company');
        //     if (_company) {
        //         this.invoiceAddress.company = _company;
        //     }
        //
        //     let _invoiceAddress = this.$ls.get('invoiceAddress');
        //     if (_invoiceAddress) {
        //         let ia = JSON.parse(_invoiceAddress);
        //         if (ia.company) {
        //             this.invoiceAddress.company = ia.company;
        //         }
        //         if (ia.street) {
        //             this.invoiceAddress.street = ia.street
        //         }
        //         if (ia.plz) {
        //             this.invoiceAddress.plz = ia.plz
        //         }
        //         if (ia.city) {
        //             this.invoiceAddress.city = ia.city
        //         }
        //         // if (ia.etage) {
        //         //     this.invoiceAddress.etage = ia.etage
        //         // }
        //     }
        // }
        //
        // if(this.deliveryAddress.street.length === 0){
        //     let _deliveryAddress = this.$ls.get('deliveryAddress');
        //     if (_deliveryAddress) {
        //         let da = JSON.parse(_deliveryAddress);
        //         if (da.company) {
        //             this.deliveryAddress.company = da.company;
        //         }
        //         if (da.street) {
        //             this.deliveryAddress.street = da.street
        //         }
        //         if (da.plz) {
        //             this.deliveryAddress.plz = da.plz
        //         }
        //         if (da.city) {
        //             this.deliveryAddress.city = da.city
        //         }
        //         if (da.etage) {
        //             this.deliveryAddress.etage = da.etage
        //         }
        //     }
        // }


        // this.usecase = store.state.goforTakeaway ? 'takeAway' : 'delivery';

        //Only for delivery usecase
        // let _deliveryAddress = this.$ls.get('deliveryAddress');
        // if (_deliveryAddress) {
        //     let da = JSON.parse(_deliveryAddress);
        //     if (da.company) {
        //         this.deliveryAddress.company = da.company;
        //     }
        //     if (da.street) {
        //         this.deliveryAddress.street = da.street;
        //     }
        //     if (da.plz) {
        //         this.deliveryAddress.plz = da.plz;
        //     }
        //     if (da.city) {
        //         this.deliveryAddress.city = da.city;
        //     }
        //     if (da.etage) {
        //         this.deliveryAddress.etage = da.etage;
        //     }
        // }


        this.updateTotal();
        // this.updateMinOrderAmount();
        // this.updateDeliveryFee();


        // //init times array
        // let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        // let allMinutes = ['00', '15', '30', '45'];
        //
        // // let isFirstTime = true;
        //
        // //day1
        // if (store.state.day1.opened) {
        //     this.internalDaySelected = '1';
        //     let relevantHours = allHours.filter(this.allowedHours);
        //     let rNow = util.getCurrentRemoteTime();
        //     let currentHour = rNow.getHours();
        //     let currentMinutes = rNow.getMinutes();
        //     let zieltermin = util.calculateZielterminOfToday(store.getters.appconfig.takeAway.delayInMinutes);
        //
        //     console.log('???? zieltermin hours = ' + zieltermin.getHours());
        //
        //     for (let hour of relevantHours) {
        //
        //         //ignore hours before zieltermin
        //         if (hour < zieltermin.getHours()) {
        //             continue;
        //         }
        //
        //         let h = '' + hour;
        //         if (hour < 10) {
        //             h = '0' + h;
        //         }
        //
        //         for (let minute of allMinutes) {
        //             if (hour === currentHour) {
        //
        //                 let _minute = parseInt(minute, 10);
        //
        //                 //ignore minutes before now
        //                 if (_minute <= currentMinutes) {
        //                     continue;
        //                 }
        //
        //                 //ignore minutes before zieltermin
        //                 if (_minute < zieltermin.getMinutes()) {
        //                     continue;
        //                 }
        //             }
        //             this.times1.push({
        //                 value: h + ':' + minute
        //             });
        //             // if (isFirstTime) {
        //             //     this.time = h + ':' + minute;
        //             //     isFirstTime = false;
        //             // }
        //         }
        //     }
        //     // this.preselectDay1();
        // }
        //
        // //day2
        // if (store.state.day2.opened) {
        //     this.internalDaySelected = '2';
        //     let relevantHours = allHours.filter(this.allowedHours);
        //     for (let hour of relevantHours) {
        //         let h = '' + hour;
        //         if (hour < 10) {
        //             h = '0' + h;
        //         }
        //         for (let minute of allMinutes) {
        //             this.times2.push({
        //                 value: h + ':' + minute
        //             });
        //             // if (isFirstTime) {
        //             //     this.time = h + ':' + minute;
        //             //     isFirstTime = false;
        //             // }
        //         }
        //     }
        //     // this.preselectDay1();
        // }

        //the payment intent is already ready to go
      } catch (e) {
        console.log('Error: ' + e.message);
        ebus.$emit('info', 'Fehler bei der Initialisierung');
      }
    },//eof init

    preselectTime() {
      //note: store.getters.selectedTime is only required if the time
      // gets selected on other pages than checkout

      // let st = store.getters.selectedTime;
      // if (this.selectedAbholDatum === 'Heute') {
      //     for (let t of this.timesToday) {
      //         if (t.value === st.value) {
      //             this.time = t;
      //             break;
      //         }
      //     }
      // } else {
      //     for (let t of this.timesTomorrow) {
      //         if (t.value === st.value) {
      //             this.time = t;
      //             break;
      //         }
      //     }
      // }
    },

    calcEarliestAbholung() {
      let delayInMinutes = util.calcDelayInMinutes(store.getters.appconfig.delivery.delayInMinutes, util.cloneMe(store.getters.cartItems));
      return util.calculateZielterminOfToday(delayInMinutes); // returns a Date
    },

    initTimesArray() {
      console.log('initTimesArray...');
      let appconfig = util.cloneMe(store.getters.appconfig);
      if (!appconfig.delivery.openingHours['1']) {
        //XHR has not finished loading the appconfig yet
        return;
      }
      //init times array

      this.timesToday.splice(0, this.timesToday.length);
      this.timesTomorrow.splice(0, this.timesTomorrow.length);

      //takwaways either on today or tomorrow so we need to filter the hours
      let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
      // let allMinutes = ['00', '15', '30', '45'];
      // let moreMinutes = ['00', '5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

      //calculate delayInMinutes
      let delayInMinutes = util.calcDelayInMinutes(appconfig.delivery.delayInMinutes, util.cloneMe(store.getters.cartItems));

      //Init Heute timesToday
      // this.internalDaySelected = '1';
      let today = util.getDayOfWeek(new Date());
      let ohsToday = appconfig.delivery.openingHours['' + today];
      // console.log('openedToday = '+ohsToday.opened);
      if (ohsToday.opened) {
        let relevantHours = allHours.filter((h) => {
          return this.allowedHours(h, ohsToday)
        });

        if (relevantHours) {
          // let nextDay = util.getNextDay();
          let rNow = new Date();
          let currentHour = rNow.getHours();
          let currentMinutes = rNow.getMinutes();
          let earliestAbholung = this.calcEarliestAbholung();
          // console.log('???? earliestAbholung utc = ' + earliestAbholung.getTime());

          for (let hour of relevantHours) {

            //ignore hours before zieltermin
            if (hour < earliestAbholung.getHours()) {
              continue;
            }

            let h = '' + hour;
            if (hour < 10) {
              h = '0' + h;
            }

            this.generateMinutes(delayInMinutes, h, hour, currentHour, currentMinutes, ohsToday, this.timesToday, true);
          }//eof of init today
        }

      }
      if (this.timesToday.length > 0) {
        this.abholDatumArray[0].value = 'Heute';
      } else {
        this.abholDatumArray[0].value = 'Heute geschlossen';
      }


      //init Morgen timesTomorrow
      // this.internalDaySelected = '1';
      let tomorrow = util.getNextDay();
      let ohsTomorrow = appconfig.delivery.openingHours['' + tomorrow];
      if (ohsTomorrow.opened) {
        let relevantHours2 = allHours.filter((h) => {
          return this.allowedHours(h, ohsTomorrow)
        });
        // let nextDay = util.getNextDay();
        // let rNow = new Date();
        // let currentHour = rNow.getHours();
        // let currentMinutes = rNow.getMinutes();
        // let zieltermin = util.calculateZielterminOfToday(appconfig.takeAway.delayInMinutes);
        if (relevantHours2) {
          for (let hour of relevantHours2) {

            //ignore hours before zieltermin
            // if (hour < zieltermin.getHours()) {
            //     continue;
            // }

            let h = '' + hour;
            if (hour < 10) {
              h = '0' + h;
            }

            this.generateMinutes(delayInMinutes, h, hour, null, null, ohsTomorrow, this.timesTomorrow, false);


          }//eof of init tomorrow
        }


      }
      if (this.timesTomorrow.length > 0) {
        this.abholDatumArray[1].value = 'Morgen';
      } else {
        this.abholDatumArray[1].value = 'Morgen geschlossen';
      }


      // this.preselectDay1();
    },

    generateMinutes(delayInMinutes, h, hour, currentHour, currentMinutes, ohs, timesArray, forToday) {
      try {
        let lessMinutes = ['00', '15', '30', '45'];
        let allMinutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
        for (let minute of allMinutes) {
          let _minute = parseInt(minute, 10);

          let utcValue;
          if (forToday) {
            utcValue = new Date();
          } else {
            utcValue = util.addDays(util.getCurrentRemoteTime(), 1);
          }
          // console.log('checkout utc = ' + nd.getTime());
          // console.log('checkout utc date = ' + nd);
          // console.log('checkout utc locale = ' + nd.toLocaleString());
          utcValue.setHours(hour);
          utcValue.setMinutes(_minute);
          let diff2Now = utcValue.getTime() - Date.now();
          let isWithin60Minutes = diff2Now < (1000 * 60 * 60);
          if (isWithin60Minutes || forToday) {
            //ignore times if delayInMinutes from now is too small
            if (diff2Now < (delayInMinutes * 60 * 1000)) {
              continue;
            }
          }

          if (forToday) {
            if (hour === currentHour) {
              //ignore minutes before now
              if (_minute <= currentMinutes) {
                continue;
              }
            }
          }

          if (!isWithin60Minutes) {
            if (!lessMinutes.includes(minute)) {
              continue; //less minutes for everything later than 60 minutes
            }
          }

          if (hour === ohs.a.fromHour) {
            if (!(ohs.a.fromMinute <= _minute)) {
              continue
            }
          }
          if (hour === ohs.a.tillHour) {
            if (!(_minute <= ohs.a.tillMinute)) {
              continue
            }
          }
          if (hour === ohs.b.fromHour) {
            if (!(ohs.b.fromMinute <= _minute)) {
              continue
            }
          }
          if (hour === ohs.b.tillHour) {
            if (!(_minute <= ohs.b.tillMinute)) {
              continue
            }
          }

          timesArray.push({
            value: h + ':' + minute,
            display: 'ca. ' + h + ':' + minute + ' Uhr',
            utc: utcValue.getTime()
          });
        }
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('Exception in generateMinutes: ' + e.message));
      }
    },

    //only asGuest
    lazyCreateStripeBuyer(cb) {
      // let msg = {
      //     action: qconst.action$CreateStripeBuyer,
      //     fuid: firebaseUtil.getFuid(),
      //     email: util.sanitizeEmail(this.email),
      // };
      // xhr.xhrSend(true, msg, (reply) => {
      //     if (reply.ok && reply.stripeCustomerId) {
      //         store.commit('stripeCustomerId', reply.stripeCustomerId);
      //         console.log('??? stripeCustomerId = ' + reply.stripeCustomerId);
      //         cb(true);
      //         ebus.$emit('pullBuyersProfile');
      //     } else {
      //         cb(false);
      //     }
      // }, (err) => {
      //     console.log('??? error creating stripe buyer: ' + err);
      //     cb(false);
      // });
    },

    // initTimesArray() {
    //     //init times array
    //     //takwaways is always on the next day so we don't neet to filter the times
    //     let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    //     let allMinutes = ['00', '30'];
    //
    //     // let isFirstTime = true;
    //
    //     // this.internalDaySelected = '1';
    //     let relevantHours = allHours.filter(this.allowedHours);
    //     let nextDay = util.getNextDay();
    //     let relevantDay = store.getters.selectedStore.openingHours['' + nextDay];
    //     // let rNow = util.getCurrentRemoteTime();
    //     // let currentHour = rNow.getHours();
    //     // let currentMinutes = rNow.getMinutes();
    //     // let zieltermin = util.calculateZielterminOfToday(appconfig.takeAway.delayInMinutes);
    //
    //     // console.log('???? zieltermin hours = ' + zieltermin.getHours());
    //
    //     for (let hour of relevantHours) {
    //
    //         //ignore hours before zieltermin
    //         // if (hour < zieltermin.getHours()) {
    //         //     continue;
    //         // }
    //
    //         let h = '' + hour;
    //         if (hour < 10) {
    //             h = '0' + h;
    //         }
    //
    //         for (let minute of allMinutes) {
    //             let minNum = 0;
    //             if (minute !== '00') {
    //                 minNum = 30;
    //             }
    //
    //             if (hour === relevantDay.a.fromHour) {
    //                 if (!(relevantDay.a.fromMinute <= minNum)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.a.tillHour) {
    //                 if (!(minNum <= relevantDay.a.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.b.fromHour) {
    //                 if (!(relevantDay.b.fromMinute <= minNum)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.b.tillHour) {
    //                 if (!(minNum <= relevantDay.b.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //
    //             // if (hour === currentHour) {
    //             //
    //             //     let _minute = parseInt(minute, 10);
    //             //
    //             //     //ignore minutes before now
    //             //     if (_minute <= currentMinutes) {
    //             //         continue;
    //             //     }
    //             //
    //             //     //ignore minutes before zieltermin
    //             //     if (_minute < zieltermin.getMinutes()) {
    //             //         continue;
    //             //     }
    //             // }
    //
    //             let nd = util.addDays(util.getCurrentRemoteTime(), 1);
    //             // console.log('checkout utc = ' + nd.getTime());
    //             // console.log('checkout utc date = ' + nd);
    //             // console.log('checkout utc locale = ' + nd.toLocaleString());
    //             nd.setHours(hour);
    //             nd.setMinutes(minNum);
    //
    //
    //             this.times.push({
    //                 value: h + ':' + minute,
    //                 display: h + ':' + minute + ' Uhr',
    //                 utc: nd.getTime()
    //             });
    //             // if (isFirstTime) {
    //             //     this.time = h + ':' + minute;
    //             //     isFirstTime = false;
    //             // }
    //         }
    //     }
    //     // this.preselectDay1();
    // },

    // preselectDay1() {
    //     //preselect first option
    //     if (this.times1.length > 0) {
    //         this.time = this.times1[0].value;
    //     }
    // },

    // preselectDay2() {
    //     //preselect first option
    //     if (this.times2.length > 0) {
    //         this.time = this.times2[0].value;
    //     }
    // },

    allowedHours(h, dayOh) {
      // let rNow = Date.now();
      // let currentHour = rNow.getHours();

      // if (isToday) {
      //     //ignore hours before now
      //     if (h < currentHour) {
      //         return false;
      //     }
      // }
      //check period a
      let matchesA = dayOh.a.fromHour <= h && h <= dayOh.a.tillHour;
      if (matchesA) {
        return true;
      }
      if (dayOh.b.fromHour !== dayOh.b.tillHour) {
        return dayOh.b.fromHour <= h && h <= dayOh.b.tillHour;
      }
      return false;
    },

    selectMethod(pMethod) {
      this.selectedPaymentMethodId = pMethod.paymentMethodId;
      console.log('??? selected paymentMethodId=' + this.selectedPaymentMethodId);
    },

    gotoSummary() {
      this.$router.push({name: 'Korb'});
    },

    gotoAccount() {
      this.$router.push({name: 'Account'});
    },

    changeFiliale() {
      this.$router.push({name: 'Filialen', query: {select: 'true'}});
    },

    gotoPms(onlyShow) {
      // if (!onlyShow) {
      this.fastUnload = true;
      this.$ls.set('continueCheckout', true);
      // }
      this.$router.push({name: 'Zahlungsmittel'});
    },


    //Überprüfe deine Daten
    finishStep1() {
      this.$nextTick(() => {
        this.refreshForm();
        if (!this.step1Ok) {
          this.initialTry = true;
          return;
        }
        if (!this.validate()) {
          return;
        }

        checkoutUtil.reset();
        this.email = util.removeSpaces(this.email);

        this.saveForm();

        //double check
        // let err = this.step1Ok();
        // if () {
        //     return;
        // }

        // if (!store.state.user.name || store.state.user.name.length < 3) {
        //     ebus.$emit('showInfo', {title: 'Gib deinen Namen ein, um fortzufahren'});
        //     return;
        // }

        if (store.getters.cartSum === 0) {
          this.$router.push({name: 'Korb'});
          return;
        }

        // //Prüfe den Mindestbestellwert
        // if (store.getters.cartSum < store.getters.appconfig.delivery.minOrderAmount) {
        //   // if (store.getters.cartSum < store.getters.selectedStore.minOrderAmount) {
        //   // if (store.getters.cartSum < this.minOrderAmount) {
        //   //     if (this.usecase === 'delivery') {
        //   this.$router.push({name: 'Korb'});
        //   ebus.$emit('showInfo', {
        //     title: 'Bitte beachte den Mindestbestellwert von '
        //       + util.getLocalPrice(store.getters.appconfig.delivery.minOrderAmount)
        //   });
        //   return;
        //   // }
        // }

        //Prüfe Verfügbarkeit aller Waren
        // let itemsNotAvailable = [];
        // for (let itm of store.getters.cartItems) {
        //     if (itm.couponCode) {
        //         continue;
        //     }
        //     if (!plausi.itemAvailableTomorrow(itm)) {
        //         itemsNotAvailable.push(itm);
        //     }
        // }
        // if (itemsNotAvailable.length > 0) {
        //     let names = itemsNotAvailable.map(itm => itm.nameToDisplay);
        //     // let filialeName = store.getters.selectedStore.strasse + ', ' + store.getters.selectedStore.ort;
        //     ebus.$emit('showInfo', {
        //         title: 'Folgende Waren sind morgen nicht verfügbar: ' + this.$options.filters.stringList(names),
        //         text: 'Bitte entfernen Sie nicht verfügbare Waren aus dem Korb.'
        //     });
        //     this.$router.push({name: 'Korb'});
        //     return;
        // }

        this.updateTotal();

        // if (this.asGuest) {
        // store.commit('showLoading', true);
        // this.safeUnload();
        // this.currentStep = 2;

        //only for iframe
        // if (iframe.isInIframe()) {
        //     util.jumpToTop();
        // } else {
        // }

        this.checkDeliveryArea();
      });
    },

    finishStep1c() {
      this.updateTotal();
      this.currentStep = 2;
      util.closeSoftKeyBoard();
    },

    getDeliveryAddress() {
      let da = util.cloneMe(this.deliveryAddress);
      util.sanitizeProps(da, true);
      return da;
    },

    getInvoiceAddress() {
      let ia = util.cloneMe(this.deliveryAddress);
      if (!this.sameAsDeliveryAddress) {
        ia = util.cloneMe(this.invoiceAddress);
        util.sanitizeProps(ia);
      }
      return ia;
    },

    checkDeliveryArea() {
      console.log('checkDeliveryArea step geoposition');

      let da = this.getDeliveryAddress();
      this.deliveryAddressForGeoposition = da;
      setGlobalKeyValue('errorDeliveryAddress');

      //getGeoposition API
      ebus.$emit('getGeoposition', {
        address: da,
        cbAddress: 'cb-geoPositionCeckoutDelivery',
      })
    },

    finishStep1b(geopositionResult) {

      console.log('finishStep1b geopositionResult ok = ' + geopositionResult.ok);

      if (PROD_ENV) {
        let finallyAllowedDelivery = false;
        if (!geopositionResult.ok) {
          //check for allowed postal codes
          let postalCode = this.deliveryAddressForGeoposition.plz;
          if (allowedPostalCodes.includes(postalCode)) {
            finallyAllowedDelivery = true;
            console.log('geposition failed but postalCode is allowed for finallyAllowedDelivery');
            // let userMsg = 'Die Lieferadresse wurde nicht gefunden. Bitte überprüfe deine Lieferadresse.';
            // ebus.$emit('toast', userMsg);
            // //report geoposition and result
            // ebus.$emit('throwError', getErrorDetails('Geoposition failed for the delivery address ' + JSON.stringify(this.deliveryAddressForGeoposition) + " - " +
            //   "API result was " + JSON.stringify(geopositionResult)));
          } else {
            let userMsg = 'Eine Lieferung an diese Adresse ist leider nicht möglich';
            ebus.$emit('toast', userMsg);
            return;
          }
        }

        if (!finallyAllowedDelivery) {
          let msg = {
            action: action$GetDeliveryAreaInfo,
            geoPosition: geopositionResult.geoPosition,
          };
          console.log('finishStep1b geoposition result was ok: ' + JSON.stringify(msg.geoPosition));
          xhr.xhrSend(true, msg, (reply) => {
            if (reply && reply.ok) {
              console.log('finishStep1b geoposition GetDeliveryAreaInfo reply ok matching=' + !!(reply.matching));
              if (reply.matching) {
                let deliveryFee = reply.deliveryFee || 0;
                let minOrderAmount = reply.minOrderAmount || 0;
                console.log('finishStep1b geoposition update ' +
                    ' deliveryFee: ' + deliveryFee +
                    ' minOrderAmount: ' + minOrderAmount);
                this.deliveryFee = 0 + deliveryFee;
                this.minOrderAmount = 0 + minOrderAmount;
                this.updateTotal();

                //check minOrderAmount
                if (store.getters.cartSum < this.minOrderAmount) {
                  let userMsg = 'Bitte beachte den Mindestbestellwert für dieses Liefergebiet von ' +
                      this.$options.filters.price(this.minOrderAmount);
                  ebus.$emit('toast', userMsg);
                  return
                }

                this.finishStep1c();
              } else {
                let userMsg = 'Eine Lieferung an diese Adresse ist leider nicht möglich';
                ebus.$emit('toast', userMsg);
                let eMsg = 'GetDeliveryAreaInfo mismatch for geoPosition ' + JSON.stringify(msg.geoPosition) +
                    ' from address ' + getGlobalValue('errorDeliveryAddress');
                ebus.$emit('throwError', getErrorDetails(eMsg));
              }
            } else {
              let eMsg = 'finishStep1b geoposition GetDeliveryAreaInfo reply not ok for geoPosition'
                  + JSON.stringify(msg.geoPosition);
              console.log(eMsg);
              ebus.$emit('throwError', getErrorDetails(eMsg))
              ebus.$emit('toast', "Ein Fehler ist aufgetreten. Bitte versuche es erneut.");
            }
          }, (err) => {
            let eMsg = 'finishStep1b geoposition exception: ' + err.message;
            ebus.$emit('toast', "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.");
            console.log(eMsg);
            ebus.$emit('throwError', getErrorDetails(eMsg))
          });
        } else {
          // this.deliveryFee = 0;
          // this.minOrderAmount = 15;
          this.updateTotal();

          //check minOrderAmount
          if (store.getters.cartSum < this.minOrderAmount) {
            let userMsg = 'Bitte beachte den Mindestbestellwert für dieses Liefergebiet von ' +
                this.$options.filters.price(this.minOrderAmount);
            ebus.$emit('toast', userMsg);
            return
          }

          this.finishStep1c();
        }

      } else {
        this.finishStep1c();
      }


    },

    safeUnload(seconds, self) {
      try {
        if (!self) {
          self = this;
        }
        if (isNaN(seconds)) {
          seconds = 6;
        }
        let now = Date.now();
        let millis = seconds * 1000;
        let targetTime = now + millis;
        self.unloadTargetTime = targetTime
        store.commit('showLoading', true);
        setTimeout(() => {
          let diff = Date.now() - self.unloadTargetTime;
          if (diff > -600 && diff < 600) {
            store.commit('showLoading', false);
          }
        }, millis);
      } catch (e) {
        console.log('error in safeUnload: ' + e.message);
      }
    },

    //Abholzeit
    finishStep2() {
      this.$nextTick(() => {
        try {
          // //Prüfe die Öffnungszeit
          // let nextDay = util.getNextDay();
          // let oh = store.getters.selectedStore.openingHours['' + nextDay];
          // if (!oh.opened) {
          //     ebus.$emit('showInfo', {
          //         title: 'Das Restaurant hat morgen geschlossen',
          //         text: 'Bitte beachten Sie die Öffnungszeiten!'
          //     });
          //     return;
          // }

          // //Prüfe den Mindestbestellwert
          // if (store.getters.cartSum < store.getters.appconfig.takeAway.minOrderAmount) {
          //     // if (store.getters.cartSum < this.minOrderAmount) {
          //     //     if (this.usecase === 'delivery') {
          //     this.$router.push({name: 'Korb'});
          //     ebus.$emit('showInfo', {
          //         title: 'Bitte beachte den Mindestbestellwert von '
          //             + util.getLocalPrice(store.getters.appconfig.takeAway.minOrderAmount)
          //     });
          //     return;
          //     // }
          // }

          //Prüfe Abholzeit
          if (this.selectedAbholDatum.value.indexOf('schlossen') > -1
              || !this.time.value || this.time.value.length === 0 || !this.time.utc) {
            ebus.$emit('showInfo', {
              title: 'Bitte wählen Sie eine Lieferzeit aus'
            });
            return;
          }
          let dayParam = this.userSelectedHeute ? '1' : '2';
          this.deliveryDate = util.generatePickupDate(dayParam, util.cloneMe(this.time));

          // this.displayPickupDate = util.displayPickupDate(pickupDate);
          // this.displayPickupDate = util.alternativeDisplayPickupDate(this.daySelected, this.time);


          // // TODO activate for captcha
          //generate CAPTCHA
          // store.commit('showLoading', true);
          // setTimeout(() => {
          //     store.commit('showLoading', false);
          // }, 2000);
          // this.generateCaptcha((responseOrFalse) => {
          store.commit('showLoading', false);
          //     if (responseOrFalse) {
          //         this.renderCaptcha(responseOrFalse);
          //
          //         // this.preselectCreditCard();
          //
          // if (this.asGuest) {
            // this.lazyCreateStripeBuyer((ok) => {
            //     if (ok) {
            //         this.lazyCreatePaymentRequest();
            this.currentStep = 3;
            // if (iframe.isInIframe()) {

            // } else {
            util.delayScroll('confirmation');
            // }
            // util.jumpToTop(true);
            // }
            // });
          // }
          //         // } else {
          //         //     ebus.$emit('toast', 'Dein Netzwerk ist unterbrochen');
          //         //     ebus.$emit('throwError', getErrorDetails('error loading captcha');
          //         //     // ebus.$emit('showInfo', {
          //         //     //     title: 'Fehler beim Laden des Captchas',
          //         //     //     text: ''
          //         //     // });
          //         // }
          //     } else {
          //         // ebus.$emit('showInfo', {
          //         //     title: 'Fehler beim Laden des Captchas',
          //         //     text: ''
          //         // });
          //     }

          // });

        } catch (e) {
          ebus.$emit('toast', 'Dein Internet ist unterbrochen');
          ebus.$emit('throwError', getErrorDetails('error in finishStep2: ' + e.message));
        }
        // if (this.psp !== 'bar') {
        //     setTimeout(() => {
        //         util.delayScroll('paymentRadios');
        //     }, 900);
        // }
      });
    },

    reloadCaptcha() {
      // // store.commit('showLoading', true);
      // this.generateCaptcha((responseOrFalse) => {
      //     if (responseOrFalse) {
      //         this.renderCaptcha(responseOrFalse);
      //     }
      //     // store.commit('showLoading', false);
      // });
    },

    async renderCaptcha(arrayBuffer) {
      // TODO activate for captcha
      // try {
      //     // Obtain a blob: URL for the image data.
      //     let arrayBufferView = new Uint8Array(arrayBuffer);
      //     let blob = new Blob([arrayBufferView], {type: "image/jpeg"});
      //     let urlCreator = window.URL || window.webkitURL;
      //     let imageUrl = urlCreator.createObjectURL(blob);
      //     let img = document.getElementById("captchaUmage");
      // this.$nextTick(() => {
      //         img.src = imageUrl;
      // });
      //
      //     // let img = new Image();
      //     // // let response = base64Buffer;
      //     // // let binary = '';
      //     // // for (let i = 0; i < response.length; i++) {
      //     // //     binary += String.fromCharCode(response.charCodeAt(i) & 0xff);
      //     // // }
      //     //
      //     // // img.src = 'data:image/jpeg;base64,' + btoa(binary);
      //     // img.src = 'data:image/jpeg;base64,' + base64Buffer;
      //     // let canvas = document.getElementById('captchaUmage');
      //     //
      //     // let context = canvas.getContext('2d');
      //     // this.$nextTick(() => {
      //     //     context.drawImage(img, 0, 0);
      //     // });
      // } catch (e) {
      //     ebus.$emit('throwError', getErrorDetails('error in drawCaptcha: ' + e.message);
      //     console.log('error in drawCaptcha: ' + e.message);
      // }
    },

    generateCaptcha(cb) {
      // xhr.xhrGetImage('xhr/captcha/generate',
      //     // {
      //     //     'Accept': '*/*'
      //     // },
      //     (reponseData) => {
      //         if (cb) {
      //             cb(reponseData);
      //         }
      // },
      //     (err) => {
      //         if (cb) {
      //             cb(false);
      //         }
      //     }
      // );
    },

    saveForm() {
      try {
        let _fd = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          // note: this.note,
        };
        let fd = util.cloneMe(_fd);
        let ia = this.invoiceAddress;
        if (ia && ia.street && ia.street.length > 0) {
          this.$ls.set('invoiceAddress', util.cloneMe(ia));
        }
        let da = this.deliveryAddress;
        if (da && da.street && da.street.length > 0) {
          this.$ls.set('deliveryAddress', util.cloneMe(da));
        }
        util.sanitizeProps(fd);
        util.removeEmptyProps(fd);
        // util.sanitizeProps(fd.invoiceAddress);
        // util.sanitizeProps(fd.deliveryAddress);
        let san = util.sanitizePhone(fd.phone);
        if (san) {
          fd.phone = san;
        }
        let sanEmail = util.sanitizeEmail(fd.email);
        if (sanEmail) {
          fd.email = sanEmail;
        }
        if (fd.email || fd.phone) {
          this.$ls.set('formData', fd);
        }

        let user = {
          name: fd.name,
          email: fd.email,
          phone: fd.phone,
        };
        util.removeEmptyProps(user);
        store.commit('user', user);

      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('error in saveForm: ' + e.message));
      }
    },

    //Abholzeit
    // finishStep3() {
    //
    //     console.log('timeSelected: ' + this.time);
    //
    //     // this.displayPickupDate = util.displayPickupDate(pickupDate);
    //     // this.displayPickupDate = util.alternativeDisplayPickupDate(this.daySelected, this.time);
    //
    //     this.currentStep = 4;
    //
    //     if (this.psp !== 'bar') {
    //         setTimeout(() => {
    //             util.delayScroll('paymentRadios');
    //         }, 900);
    //     }
    // },

    // finishStep3() {
    //     if (this.consentA && this.consentB) {
    //         this.currentStep = 4;
    //     }
    // },

    checkMobilnummer() {
      if (!isMobileOk(this.phone)) {
        // let restName = store.state.restaurantData.restaurantName;
        ebus.$emit('showInfo', {
          title: 'Mobilnnumer notwendig',
          text: 'Durch Angabe deiner Mobilnummer können wir ' +
              +'Kontakt zu dir aufnehmen, falls es Rückfragen zu deiner Bestellung geben sollte'
        });
        return false;
      }
      return true;
    },

    // allowedHours(h) {
    //     let nextDay = util.getNextDay();
    //     let relevantDay = store.getters.selectedStore.openingHours['' + nextDay];
    //     // let relevantDay = store.state['day' + this.internalDaySelected];
    //     // let rNow = util.getCurrentRemoteTime();
    //     // let currentHour = rNow.getHours();
    //
    //     // if (this.internalDaySelected === '1') {
    //     // //ignore hours before now
    //     // if (h < currentHour) {
    //     //     return false;
    //     // }
    //     // }
    //
    //     //check period a
    //     let matchesA = relevantDay.a.fromHour <= h && h <= relevantDay.a.tillHour;
    //     if (matchesA) {
    //         return true;
    //     }
    //
    //     //check period b
    //     if (relevantDay.b.fromHour !== relevantDay.b.tillHour) {
    //         return relevantDay.b.fromHour <= h && h <= relevantDay.b.tillHour;
    //     }
    //     return false;
    // },

    // allowedMinutes(m) {
    //     if (m % 30 === 0) {
    //         return true;
    //     }
    //
    //     return false;
    // },

    // stripeCollectPaymentMethod() {
    //     stripeUtil.createCardElement();
    //     stripeUtil.cardElement.mount('#card-element');
    //
    //     setTimeout(() => {
    //         this.initStripeSubmitButton();
    //     }, 600);//the mount takes a view milliseconds
    // },

    // initStripeSubmitButton() {
    //     const cardholderName = document.getElementById('cardholder-name');
    //     const cardButton = document.getElementById('card-button');
    //
    //     //always provide the customer’s name, email, billing address,
    //     // and shipping address (if available) to the stripe.handleCardPayment call.
    //     cardButton.addEventListener('click', async (ev) => {
    //         //Note that stripe.handleCardPayment may take several seconds to complete. During that time,
    //         // you should disable your form from being resubmitted and show a waiting indicator like a spinner.
    //         let _billing_details = {
    //             name: store.state.user.name,
    //             email: store.state.user.email
    //         };
    //         if (store.state.user.phone) {
    //             _billing_details.phone = store.state.user.phone;
    //         }
    //
    //         const {paymentIntent, error} = await stripeUtil.stripe.handleCardPayment(
    //             this.clientSecret, stripeUtil.cardElement, {
    //                 payment_method_data: {
    //                     billing_details: _billing_details
    //                 },
    //                 save_payment_method: true,
    //                 receipt_email: store.state.user.email
    //             }
    //         );
    //
    //         if (error) {
    //             // Display error.message in your UI.
    //             console.log('Payment error: ' + JSON.stringify(error));
    //         } else {
    //             // The payment has succeeded. Display a success message.
    //             console.log('Payment succeeded');
    //         }
    //     });
    // },

    doOrder() {
      if (!this.psp || this.psp === 'none') {
        return;
      }
      this.createdAt = 0;
      if (this.wait) {
        return
      }
      this.wait = true;
      setTimeout(() => this.wait = false, 2000);
      if (this.psp === 'credit' || this.psp === 'wallet') {
        store.commit('showLoading', true);
        //enable when using stripe
        this.createStripePaymentIntent();
      } else if (this.psp === 'paypal') {
        // store.commit('showLoading', true);
        // this.createStripePaymentIntent();
        //PayPal has its own Button
      } else if (this.asGuest && this.checkMobilnummer()) {
        //Barzahlung
        this.saveOrder(false);
      }
    },

    createStripePaymentIntent() {
      //TODO activate for online
      //             this.order = this.generateOrder();
      //             let msg = {
      //                 action: qconst.action$StripeCreatePaymentIntent,
      //                 // restaurantId: store.state.restaurantData.restaurantId,
      //                 amount: this.total,
      //                 userInfo: util.cloneMe(store.state.user),
      //                 stripeCustomerId: store.state.stripeCustomerId,
      //                 paymentMethodId: this.selectedPaymentMethodId,
      //                 order: util.cloneMe(this.order)
      //             };
      //             if (this.asGuest) {
      //                 msg.userInfo = {
      //                     fuid: bootstrap.getBtaste(),
      //                     name: '' + this.name,
      //                     email: util.sanitizeEmail(this.email),
      //                     phone: '' + this.phone,
      //                 };
      //             }
      //             console.log('??? sending StripeCreatePaymentIntent to the server');
      //             xhr.xhrSend(true, msg, (reply) => {
      //                 console.log('??? got some reply');
      //                 if (reply.ok) {
      //                     try {
      //                         let paymentIntentId = reply.paymentIntentId;
      //                         let clientSecret = reply.clientSecret;
      //                         console.log('??? paymentIntentId=' + paymentIntentId);
      //                         console.log('??? clientSecret=' + clientSecret);
      //                         this.$nextTick(() => {
      //                             let status = reply.status;
      //                             // this.paymentIntentAmount = msg.amount;
      //                             this.orderId = reply.id; //is null when requires action (SCA)
      //                             this.paymentIntentId = paymentIntentId; // maybe not needed
      //                             this.clientSecret = clientSecret;
      //                             this.paymentIntentStatus = status; // maybe not needed
      //                             this.orderNumber = reply.orderNumber; // maybe not needed
      //                             this.uniqueOrderId = reply.uniqueOrderId; // maybe not needed
      //                             this.createdAt = reply.createdAt; // maybe not needed  server-side createdAt
      //
      //                             this.order.createdAt = reply.createdAt;
      //                             this.order.orderNumber = reply.orderNumber;
      //                             this.order.uniqueOrderId = reply.uniqueOrderId;
      //                             this.order.paymentInfo.paymentIntentId = reply.paymentIntentId;
      //                             this.order.paymentInfo.paymentMethodId = reply.paymentMethodId;
      //                             this.stripePreAuth = reply.stripePreAuth;
      //
      //                             /*
      //                             results in the database to
      //                              "paymentInfo" : {
      //     "amount" : 13.6,
      //     "psp" : "stripe",
      //     "itemsTotal" : 16,
      //     "deliveryFee" : 0,
      //     "paymentIntentId" : "pi_1GAJiZJjaN1KCNAM2oy9mIX1",
      //     "paymentMethodId" : "pm_1G3nKoKVLzyCJeASoujaRbYH"
      // },
      //                             */
      //
      //                             console.log('??? paymentIntent status : ' + status);
      //
      //                             if (status === 'requires_action') {
      //                                 this.handleRequiresAction();
      //                             } else if (status === 'requires_capture') {
      //
      //                                 //status requires_capture means that stripePreAuth and the order has been
      //                                 //already been saved at the server
      //
      //                                 ebus.$emit('loadLastOrders');//preload last orders
      //                                 this.usingPaymentRequest = false;
      //                                 // this.notifyInfo('Die Zahlung wurde erfolgreich autorisiert');
      //
      //                                 //save as lastOrder
      //                                 this.order.id = reply.id;
      //                                 store.commit('showLoading', false);
      //                                 this.$ls.set('lastOrder', this.order);
      //
      //                                 // ebus.$emit('orderSuccess');
      //
      //                                 this.logPurchase();
      //                                 store.commit('deleteAllCartItems');
      //                                 this.$router.replace({name: 'Bestaetigung'});
      //                                 //goto success page
      //
      //                                 // this.saveOrder();
      //                             } else {
      //                                 this.usingPaymentRequest = false;
      //                                 store.commit('showLoading', false);
      //                                 this.notifyError('Unbekannter Status: ', status);
      //                             }
      //                         });
      //                     } catch (e) {
      //                         this.notifyError('Unerwarteter Fehler');
      //                         store.commit('showLoading', false);
      //                     }
      //                 } else {
      //                     store.commit('showLoading', false);
      //                     this.usingPaymentRequest = false;
      //                     this.notifyError('Unerwateter Fehler bei der Verarbeitung deiner Bestellung. Bitte versuche es gleich nochmal.');
      //                 }
      //             }, (err) => {
      //                 store.commit('showLoading', false);
      //                 this.usingPaymentRequest = false;
      //                 console.log('??? error creating intent: ' + err);
      //                 this.notifyError('Fehler bei der Zahlungsabwicklung: ', err);
      //             })
    },


    logPurchase() {
      // let param = {
      //     currency: 'EUR',
      //     value: this.total,
      //     items: util.cloneMe(firebaseUtil.getGitemsFromCart(store.getters.cartItems)),
      //     usecase: this.usecase
      // };
      // for (let itm of store.getters.cartItems) {
      //     let isCoupon = 'nameToDisplay' in itm;
      //     if (isCoupon) {
      //         param.coupon = itm.nameToDisplay;
      //         break
      //     }
      // }
      // firebaseUtil.gevent('purchase', param);
    },


    // updateMinOrderAmount() {
    //     if (store.getters.selectedStore.minOrderAmount) {
    //         this.minOrderAmount = store.getters.selectedStore.minOrderAmount;
    //         this.fee = store.getters.selectedStore.fee;
    //     }
    // },

    // updateDeliveryFee() {
    //     this.deliveryFee = 0;
    //     this.minOrderAmount = 0;
    //     for (let area of appconfig.deliveryAreas) {
    //         if (area.plz === this.deliveryAddress.plz) {
    //             this.deliveryFee = area.fee;
    //             this.minOrderAmount = area.minOrderAmount;
    //             console.log('updateDeliveryFee deliveryFee = ' + area.fee);
    //             console.log('updateDeliveryFee minOrderAmount = ' + area.minOrderAmount);
    //             return true;
    //         }
    //     }
    //     return false;
    // },

    generateOrder() {
      try {

        let order = {
          clientId: '' + this.$ls.get('clientId'),
          lastMenuUpdate: this.$ls.get('lastMenuUpdate'),
          sentToPos: false,
          asGuest: this.asGuest,
          type: 'selfOrder',
          //TODO activate for firebase
          fuid: null,
          // fuid: (firebaseUtil.getFuid() ? firebaseUtil.getFuid() : null),
          btaste: bootstrap.getBtaste(),
          domain: window.location.hostname,
          channel: 'on-the-go',
          usecase: this.usecase,
          // restaurantId: store.getters.restId,
          createdAt: Date.now(),
          //Note: delayInMinutes is irrelevant for pre-orders (asap === false)
          // delayInMinutes: store.getters.delayInMinutes,
          // expectedDelayInMinutes: store.getters.delayInMinutes,
          orderData: util.cloneMe(store.getters.cartItems),
appliedDiscounts: util.cloneMe(store.getters.appliedDiscounts),
          // company: '' + this.company,
          // userInfo: util.cloneMe(store.state.user),
          deliveryDate: util.cloneMe(this.deliveryDate),
          targetTime: this.deliveryDate.utc,
          onlinePay: false,
          directPay: false,
          psp: '' + this.psp,
          paymentInfo: {
            psp: '' + this.psp,
            amount: this.total
          },
          deliveryFee: 0 + this.deliveryFee,
          paymentAuth: {},
          note: '',
        };

        // alert('order deliveryFee: ' + order.deliveryFee);

        if (qconst.withPosApi) {
          order.posConfirmedTime = 0;
        }

        let pushToken = this.$ls.get('pushToken');
        if (pushToken) {
          order.pushToken = pushToken;
        }

        if (store.getters.enableStempel) {
          order.collectStempel = true;
          order.stempelType = store.getters.stempelType;
        }
        if (this.note) {
          order.note = '' + this.note;
        }

        // if (this.asGuest) {
          order.userInfo = {
            btaste: bootstrap.getBtaste(),
            name: '' + this.name,
            // kundennummer: '' + this.kundennummer,
            email: util.sanitizeEmail(this.email),
            phone: '' + this.phone,
          };
        // }
        if(!this.asGuest){
          order.userInfo.fuid=  firebaseUtil.getFuid();F
        }

        order.deliveryAddress = this.getDeliveryAddress();
        order.invoiceAddress = this.getInvoiceAddress();

        util.sanitizeProps(order);

        //add app string
        // if (breakpoints.getCurrentDevice() === 'xs') {
        //     order.app = 'LIEFERMAXX Mobile App'
        // } else {
        //     order.app = 'LIEFERMAXX App'
        // }

        //add operating system
        order.userAgentData = window.navigator.userAgentData;

        // if (this.onlinePay) {
        //     // order.orderNumber = this.orderNumber;
        //     // order.uniqueOrderId = this.uniqueOrderId;
        //
        //     order.paymentInfo.psp = 'stripe';
        //     // order.paymentInfo.paymentIntentId = this.paymentIntentId;
        //     // order.paymentInfo.paymentMethodId = this.selectedPaymentMethodId;
        // }
        // if (this.usecase === 'delivery') {
        //     if (this.deliveryAddress.etage.length > 0) {
        //         order.deliveryAddress.etage = this.deliveryAddress.etage;
        //     }
        order.paymentInfo.itemsTotal = store.getters.cartSum;
        // order.paymentInfo.deliveryFee = 0+this.deliveryFee;// + store.state.deliveryFee;
        //     // let fee = null;
        //     // for (let area of store.getters.appconfig.deliveryAreas) {
        //     //     if (area.plz === order.deliveryAddress.plz) {
        //     //         fee = area.fee;
        //     //         break;
        //     //     }
        //     // }
        //     // if (fee === null) {
        //     //     //error
        //     //     this.notifyError('Fehler bei den Lieferkosten');
        //     //     return null;
        //     // }
        //     // order.paymentInfo.amount = this.total;
        // } else {
        // order.pickupStore = util.cloneMe(store.getters.selectedStore);
        // delete order.pickupStore.openingHours;
        // order.storeId = '' + store.getters.selectedStore.filialnummer;
        // }
        return util.cloneAndRemoveAllDisplayKeys(order, ['delay']);
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('Exception in generateOrder: ' + e.message));
        return null;
      }
    },

    //is never invoked for stripe paymentIntent with requires_pacture = true (order gets saved in createPaymentIntent)
    saveOrder(useExistingOrder, retryCount) {
      if (!retryCount) {
        this.safeUnload();
      }
      setTimeout(() => {
        this.$nextTick(() => {
          this._saveOrder(useExistingOrder, retryCount);
        });
      }, 1 * 1000);
    },
    _saveOrder(useExistingOrder, retryCount) {
      if (!retryCount) {
        retryCount = 0;
      }
      // if (store.getters.restId === 'x0') {
      //     return;
      // }
      console.log('??? save order');
      let checkpoints = 0;
      try {
        this.safeUnload();
        let order;
        if (useExistingOrder) {
          order = util.cloneMe(this.order);
        } else {
          ++checkpoints;
          order = this.generateOrder();
          ++checkpoints;
        }

        let timeout = qconst.withPosApi ? (60 * 1000) : (10 * 1000);
        let msg = {
          action: qconst.action$SaveNewOrder,
          order: order,
          // captchaText: '' + this.captchaInput
        };

        // msg.paymentIntentId = this.paymentIntentId;
        // msg.paymentMethodId = this.paymentMethodId;
        if (this.psp === 'credit' || this.psp === 'wallet') {
          // useExistingOrder is always be true if psp=stripe because intent status here is requires_action
          msg.stripeCustomerId = store.state.stripeCustomerId;
          msg.saveStripeAuth = useExistingOrder;//tell the server to save the stripePreAuth or not
          if (useExistingOrder) {
            msg.stripePreAuth = util.cloneMe(this.stripePreAuth);
          }
        } else if (this.psp === 'paypal') {
          //paypalPreAuth contains
          // paypalOrderId,orderNumber,uniqueOrderId,createdAt,amount,paypalAuthId,sellerAccountId,fuid
          msg.paypalPreAuth = util.cloneMe(this.paypalPreAuth);

          //at this point neither the order nor the paypalPreAuth are saved
        }
        ++checkpoints;

        // setTimeout(() => {
        //     store.commit('showLoading', false);
        // }, 3000);
        xhr.xhrSend(true, msg, (reply) => {
          //either ok with orderId or notOk
          // store.commit('showLoading', false);
          ++checkpoints;
          if (reply.ok) {
            // ebus.$emit('loadLastOrders');//preload last orders
            // ebus.$emit('info', 'Deine Bestellung wurde erfolgreich übermittelt!');
            // this.notifyInfo('Deine Bestellung war erfolgreich!');
            //reply.orderId
            console.log('??? orderId = ' + reply.id);

            //save as lastOrder
            let finalOrder = Object.assign(util.cloneMe(this.order), reply);
            store.commit('updateOrder', finalOrder);
            this.order = finalOrder;
            let uniqueOrderId = '' + finalOrder.uniqueOrderId;
            ++checkpoints;
            // this.$ls.set('lastOrder', order);
            // ebus.$emit('orderSuccess');
            // this.logPurchase();
            ++checkpoints;

            const checkoutItems = cloneMe(store.getters.cartItems);
            ebus.$emit('fastUpdateInventory', checkoutItems);

            store.commit('deleteAllCartItems');
            ++checkpoints;
            // this.$router.replace({name: 'Bestaetigung'});
            setTimeout(() => {
              this.$router.replace({
                name: 'Bestellung',
                params: {
                  uniqueOrderId: uniqueOrderId,
                }
              });
              ebus.$emit('showInfo', {
                title: 'Die Bestellung wurde erfolgreich durchgeführt',
                text: ''
              });
            }, 1200);
          } else {
            checkpoints += 100;
            if (reply.captchaError || reply.secTokenError) {
              checkpoints += 200;
              ebus.$emit('forceReload');
              // this.notifyError('Der eingegebenen Buchstaben sind ungültig.', 'Bitte gib die Buchstaben im letzen Schritt erneut ein!');
            } else if (reply.forceReload) {
              alert('Hinweis: Nach einer kurzen Aktualisierung der App, die automatisch durchgeführt wird,' +
                  ' kannst du deine Bestellung abschließen.');
              ebus.$emit('forceReload');
            } else {
              checkpoints += 300;
              this.notifyError('Fehler bei der Verarbeitung der Bestellung', 'Bitte versuche es erneut');
              // this.reloadCaptcha();
              // checkpoints += 10000;

              // store.commit('showLoading', false);

              ebus.$emit('throwError', getErrorDetails('Error in save new order delivery np, checkpoints: ' + checkpoints));
            }
          }
        }, (err) => {
          checkpoints += 20000;
          ebus.$emit('throwError', getErrorDetails('Transport error in save new order delivery np; checkpoints: ' + checkpoints + ' retryCount: ' + retryCount + ' error:' + err.message));
          this.notifyError('Unerwarteter Fehler', 'Eventuell ist dein Internet unterbrochen');

          if (!retryCount || retryCount < 3) {
            //retry
            let r = ++retryCount;
            setTimeout(() => {
              this.saveOrder(useExistingOrder, r);
            }, 1000);
          } else {
            // store.commit('showLoading', false);
            this.notifyError('Unerwarteter Fehler', 'Eventuell ist dein Internet unterbrochen');
            // setTimeout(() => {
            //     ebus.$emit('reload', true)
            // }, 2500);
          }
        }, timeout);
      } catch (e) {
        checkpoints += 30000;
        ebus.$emit('throwError', getErrorDetails('Exception in save new order delivery np: ' + e.message + '; checkpoints: ' + checkpoints));
        console.log('!!!!! error: ' + e.message);
      }

    },

    notifyError(text, err) {
      ebus.$emit('info', 'Fehler: ' + text + ' ' + (err || ''));
    },

    // notifyInfo(text, err) {
    //     this.$notify({
    //         type: 'info',
    //         title: text,
    //         text: err || ''
    //     });
    // },

    // handleRequiresAction() {
    //     console.log('??? handle requires_action with usingPaymentRequest = ' + this.usingPaymentRequest);
    //
    //     if (this.usingPaymentRequest) {
    //         (async () => {
    //             const {error} = await stripeUtil.connectedAccount.handleCardPayment(this.clientSecret);
    //             this.usingPaymentRequest = false;
    //             store.commit('showLoading', false);
    //             if (error) {
    //                 // The payment failed -- ask your customer for a new payment method.
    //                 console.log('??? handleCardPayment failed');
    //                 console.log('??? handleCardPayment error: ' + JSON.stringify(error));
    //                 store.commit('showLoading', false);
    //                 this.notifyError('Fehler bei der Autorisierung der Zahlung');
    //             } else {
    //                 // The payment SCA auth has succeeded.
    //                 console.log('??? handleCardPayment succeeded');
    //                 this.saveOrder(true);
    //             }
    //         })();
    //     } else {
    //         (async () => {
    //
    //             // handleCardAction() leads to the follwing error when payment method comes from payment request button:
    //             // IntegrationError: handleCardAction: The PaymentIntent supplied does not require manual server-side confirmation.
    //             // Please use handleCardPayment instead to complete the payment.
    //
    //             const {error: errorAction, paymentIntent} =
    //                 await stripeUtil.connectedAccount.handleCardAction(this.clientSecret);
    //             this.usingPaymentRequest = false;
    //             store.commit('showLoading', false);
    //             if (errorAction) {
    //                 console.log('??? handleRequiresAction failed');
    //                 console.log('??? handleRequiresAction errorAction: ' + JSON.stringify(errorAction));
    //                 store.commit('showLoading', false);
    //                 this.notifyError('Fehler bei der Autorisierung der Zahlung');
    //                 // Show error from Stripe.js in payment form
    //             } else {
    //                 //Payment SCA auth succeeded
    //                 console.log('??? handleRequiresAction succeeded');
    //                 this.saveOrder(true);
    //                 //As authentication and other required steps occur asynchronously on the client,
    //                 // you must monitor for the payment_intent.succeeded and payment_intent.payment_failed
    //                 // events on your server in order to determine the outcome of the process and handle
    //                 // fulfillment upon success.
    //             }
    //         })();
    //     }
    //
    // }


  }
}
</script>

<style lang="scss" scoped>
@import '../styles/base';
@import '../styles/forms';

.page {
  /*To debug textfield background*/
  //background-color: $color-secondary;

  select {
    -moz-appearance: menulist !important;
    -webkit-appearance: menulist !important;
  }
}

.datefields {
  width: 70%;
  min-width: 250px;
  max-width: 350px;
}


.termin {
  margin: 8px 0 8px 8px;
}


.actions {

  td {
    text-align: left;
    padding: 1.5%;
  }
}

.bestelldaten {
  /*<!--background-color: $color-darkblue;-->*/

  tr {
    td:first-child {
      color: rgba(black, 0.7)
    }

    td:last-child {
      padding-left: 15px;
      /*color: black;*/
    }

  }

}

/*.vvd {*/
/*    background-color: rgba(white,0.7);*/
/*}*/


.ccard {
  margin-right: 16px;
  background: none;
  color: $font-color;
  //border-left: 6px solid $accent;
  //border-radius: $box-border-radius;
  padding: 8px;
  //@include material-shadow(1);

  /*<!--&:hover {-->*/
  /*<!--    @include material-shadow(2);-->*/
  /*<!--}-->*/

  .expLabel {
    font-size: smaller;
  }
}

</style>
